import * as React from "react";
import { Link } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import FormTypeSidebar from "./FormTypeSidebar";
import FormTypeStore from "../../../../stores/FormTypeStore";
import IndexStore from "../../../../stores/IndexStore";
import FieldRelationsStore from "../../../../stores/FieldRelationsStore";
import FieldStore from "../../../../stores/FieldStore";
import PremiumAIStore from "../../../../stores/PremiumAIStore";
import SystemAuditLoggingStore from "../../../../stores/SystemAuditLoggingStore";
import {
  LoadFormType,
  UpdateFormType,
  UpdateExtender,
  GetPluginModel,
  GetAllDataSources,
  RemoveExtender
} from "../../../../actions/FormTypeActions";
import {
  UpdateIndex,
  GetIndexFieldsForFormType,
  ReIndexFormType,
  GetBuildPercentage,
  DeleteIndex,
  CancelReindexing,
  UpdateBuildStatus,
  GetIndexDocCounts,
  ReIndexFormTypeWithParams
} from "../../../../actions/IndexActions";
import {
  GetFieldRelations,
  UpdateFieldRelation,
  DeleteFieldRelation
} from "../../../../actions/FieldRelationActions";
import {
  GetAllFormTypes,
  GetFieldsForOtherFormType
} from "../../../../actions/FieldActions";
import { GetFormTypeAudit } from "../../../../actions/SystemAuditLogsActions";
import actionTypes from "../../../../actions/ActionTypes";
import { PostAlert } from "../../../../actions/AlertActions";
import NavStore from "../../../../stores/NavStore";
import { AcceptNav } from "../../../../actions/NavActions";
import FieldEditor from "../../../Regular/Document/FieldEditor";
import { GetPremiumAIGenericFields } from "../../../../actions/PremiumAIActions";
const windowOffset = 325;
const FieldDisplayColumn = (p) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, p.data.type === "Text" && /* @__PURE__ */ React.createElement("span", { style: { color: "#1F8F8F" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-font" }), " "), p.data.type === "Number" && /* @__PURE__ */ React.createElement("span", { style: { color: "#1F8F8F" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-hashtag" }), " "), p.data.type === "Date" && /* @__PURE__ */ React.createElement("span", { style: { color: "#1F8F8F" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-calendar" }), " "), /* @__PURE__ */ React.createElement("span", null, p.data.name), p.data.isHidden && /* @__PURE__ */ React.createElement("span", { className: "ms-2", style: { color: "#919191" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-eye-slash" })));
};
class FormTypeView extends React.Component {
  dragField = {};
  dragTarget = {};
  constructor() {
    super();
    this.state = {
      currentFormType: {
        formTypeId: 0,
        name: "",
        fieldSets: [],
        tables: [],
        isNew: true,
        indexId: 0
      },
      currentFieldSet: {
        name: "",
        orderId: 0,
        fields: []
      },
      editField: {
        name: "",
        systemName: "",
        type: "Text",
        format: "",
        isCalculated: false
      },
      editExtender: {
        extenderId: -1,
        type: 1,
        fieldId: -1,
        controlsChildren: false,
        sortAlphabetical: true,
        fieldName: "",
        availableDependencies: [],
        dependencies: []
      },
      isDirty: false,
      currentView: "fields",
      addingField: false,
      isSaving: false,
      showFieldEditor: false,
      showExtenderEditor: false,
      newField: {
        fieldId: 0,
        name: "",
        systemName: "",
        type: "Text",
        isDirty: true
      },
      editFieldSet: {
        name: "",
        isActive: true
      },
      allSources: [
        {
          id: 1,
          name: "TrinDocs"
        },
        {
          id: 2,
          name: "TWO"
        },
        {
          id: 3,
          name: "GPACME"
        },
        {
          id: 4,
          name: "TrinDocs_Companion"
        }
      ],
      showTableEdit: false,
      isRearranging: true,
      showNewIndex: false,
      showDeleteIndex: false,
      showAboutFieldRelations: false,
      defaultIndexName: "",
      currentIndexes: [],
      currentQuery: void 0,
      doesIndexExist: false,
      currentlyIndexing: false,
      currentIndexPercent: 0,
      isIndexSectionDirty: false,
      showRemoveExtender: false,
      fieldRelations: [],
      baseFields: [],
      formTypes: [],
      relatedFields: [],
      addingFieldRelation: false,
      selectedBaseField: void 0,
      selectedRelatedFormType: void 0,
      selectedRelatedField: void 0,
      isTwoWayLink: false,
      displayConfirmDeletePopup: false,
      fieldRelationToDelete: void 0,
      deleteTwoWayLink: false,
      startBuildImmediately: false,
      errorMessageForExtenders: "",
      showOptionRemoveExtender: false,
      workHeight: 300,
      screenHeight: window.innerHeight - windowOffset,
      showReindex: false,
      activeCount: 0,
      completedCount: 0,
      deletedCount: 0,
      reindexActiveDocs: true,
      reindexCompleteDocs: false,
      reindexDeletedDocs: false,
      reindexColumns: true,
      reindexColumnOptions: {
        indexAll: true,
        colOptions: []
      },
      reindexText: true,
      reindexRelated: false,
      showAboutFieldType: false,
      dropOverId: 0,
      dropUnderId: 0,
      buildStatus: 0,
      showNav: false,
      navDestination: "",
      currentFieldList: [],
      fieldColumnDefs: [],
      lowerHeight: 220,
      myTheme: themeQuartz.withParams({
        fontSize: 10,
        headerFontSize: 25
      }),
      enableTwoWayLink: true,
      hasNameMatch: false,
      nameMatchError: "",
      genericFields: [],
      genericHeaderFields: [],
      genericLineFields: [],
      auditLogs: [],
      formTypeAudit: [],
      expandedAuditSessions: {},
      queryDiffPopup: null
    };
    this.loadFormTypeFromDB = this.loadFormTypeFromDB.bind(this);
    this.onFormTypesChange = this.onFormTypesChange.bind(this);
    this.onFieldRelationsChange = this.onFieldRelationsChange.bind(this);
    this.onFieldsChange = this.onFieldsChange.bind(this);
    this.checkParams = this.checkParams.bind(this);
    this.editTableValue = this.editTableValue.bind(this);
    this.switchView = this.switchView.bind(this);
    this.onChangeFTName = this.onChangeFTName.bind(this);
    this.addFields = this.addFields.bind(this);
    this.hideaddFields = this.hideaddFields.bind(this);
    this.addFieldRelations = this.addFieldRelations.bind(this);
    this.hideaddFieldRelations = this.hideaddFieldRelations.bind(this);
    this.addFieldClick = this.addFieldClick.bind(this);
    this.onNewFieldKeyDown = this.onNewFieldKeyDown.bind(this);
    this.onSave = this.onSave.bind(this);
    this.addTableClick = this.addTableClick.bind(this);
    this.switchFieldSet = this.switchFieldSet.bind(this);
    this.addNewTableClick = this.addNewTableClick.bind(this);
    this.tableItemClick = this.tableItemClick.bind(this);
    this.cancleTableClick = this.cancleTableClick.bind(this);
    this.updateTableClick = this.updateTableClick.bind(this);
    this.rearrangeTableClick = this.rearrangeTableClick.bind(this);
    this.toggleRearrange = this.toggleRearrange.bind(this);
    this.editField = this.editField.bind(this);
    this.editExtender = this.editExtender.bind(this);
    this.editFieldValue = this.editFieldValue.bind(this);
    this.editCancel = this.editCancel.bind(this);
    this.editUpdate = this.editUpdate.bind(this);
    this.toggleNewIndex = this.toggleNewIndex.bind(this);
    this.toggleDeleteIndex = this.toggleDeleteIndex.bind(this);
    this.editDefaultIndexName = this.editDefaultIndexName.bind(this);
    this.indexFieldChange = this.indexFieldChange.bind(this);
    this.startIndexCreation = this.startIndexCreation.bind(this);
    this.closeExtenderEdit = this.closeExtenderEdit.bind(this);
    this.configureExtender = this.configureExtender.bind(this);
    this.removeExtender = this.removeExtender.bind(this);
    this.addDataSrc = this.addDataSrc.bind(this);
    this.switchDataSource = this.switchDataSource.bind(this);
    this.removeQuery = this.removeQuery.bind(this);
    this.saveExtenderChanges = this.saveExtenderChanges.bind(this);
    this.addExtenderDependency = this.addExtenderDependency.bind(this);
    this.injectDependency = this.injectDependency.bind(this);
    this.onIndexChange = this.onIndexChange.bind(this);
    this.reindexDocuments = this.reindexDocuments.bind(this);
    this.reindexingComplete = this.reindexingComplete.bind(this);
    this.cancelReindexing = this.cancelReindexing.bind(this);
    this.onTimerClick = this.onTimerClick.bind(this);
    this.updateIndex = this.updateIndex.bind(this);
    this.updateIndexAndReindex = this.updateIndexAndReindex.bind(this);
    this.deleteIndex = this.deleteIndex.bind(this);
    this.generatePluginModel = this.generatePluginModel.bind(this);
    this.toggleRemoveExtender = this.toggleRemoveExtender.bind(this);
    this.onConfirmRemoveExtender = this.onConfirmRemoveExtender.bind(this);
    this.selectFormType = this.selectFormType.bind(this);
    this.toggleTwoWayLink = this.toggleTwoWayLink.bind(this);
    this.editSelectedRelatedField = this.editSelectedRelatedField.bind(this);
    this.editSelectedBaseField = this.editSelectedBaseField.bind(this);
    this.addFieldRelationClick = this.addFieldRelationClick.bind(this);
    this.initialDeleteFieldRelation = this.initialDeleteFieldRelation.bind(this);
    this.toggleConfirmDelete = this.toggleConfirmDelete.bind(this);
    this.toggleDeleteTwoWayLink = this.toggleDeleteTwoWayLink.bind(this);
    this.toggleAboutFieldRelations = this.toggleAboutFieldRelations.bind(this);
    this.toggleAboutFieldType = this.toggleAboutFieldType.bind(this);
    this.confirmDeleteFieldRelation = this.confirmDeleteFieldRelation.bind(this);
    this.deleteField = this.deleteField.bind(this);
    this.newFieldBlur = this.newFieldBlur.bind(this);
    this.newTableBlur = this.newTableBlur.bind(this);
    this.removeTableClick = this.removeTableClick.bind(this);
    this.editStartBuildImmediately = this.editStartBuildImmediately.bind(this);
    this.setFieldDragging = this.setFieldDragging.bind(this);
    this.onFieldDragOver = this.onFieldDragOver.bind(this);
    this.onFieldDrop = this.onFieldDrop.bind(this);
    this.toggleSelectAllIndex = this.toggleSelectAllIndex.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.RemoveIndexOption = this.RemoveIndexOption.bind(this);
    this.AddIndexOption = this.AddIndexOption.bind(this);
    this.toggleRebuildIndex = this.toggleRebuildIndex.bind(this);
    this.showRebuildIndex = this.showRebuildIndex.bind(this);
    this.changeReindexSettings = this.changeReindexSettings.bind(this);
    this.startIndexBuild = this.startIndexBuild.bind(this);
    this.onNavRequest = this.onNavRequest.bind(this);
    this.onSaveAndNav = this.onSaveAndNav.bind(this);
    this.onStay = this.onStay.bind(this);
    this.FieldButtons = this.FieldButtons.bind(this);
    this.updateFieldList = this.updateFieldList.bind(this);
    this.onFieldRowDragMove = this.onFieldRowDragMove.bind(this);
    this.checkMatchingRelation = this.checkMatchingRelation.bind(this);
    this.checkNames = this.checkNames.bind(this);
    this.removeExtenderDependency = this.removeExtenderDependency.bind(this);
    this.onPremiumAIChange = this.onPremiumAIChange.bind(this);
    this.editAIField = this.editAIField.bind(this);
    this.onSystemAuditChange = this.onSystemAuditChange.bind(this);
  }
  componentDidMount() {
    FormTypeStore.addChangeListener(this.onFormTypesChange);
    IndexStore.addChangeListener(this.onIndexChange);
    NavStore.addChangeListener(this.onNavRequest);
    FieldRelationsStore.addChangeListener(this.onFieldRelationsChange);
    FieldStore.addChangeListener(this.onFieldsChange);
    PremiumAIStore.addChangeListener(this.onPremiumAIChange);
    SystemAuditLoggingStore.addChangeListener(this.onSystemAuditChange);
    this.loadFormTypeFromDB();
    this.interval = setInterval(this.onTimerClick, 1500);
    window.onresize = this.onWindowResize;
    document.title = "TrinDocs - Form Types";
    let colDefs = [
      { field: "name", cellRenderer: FieldDisplayColumn, rowDrag: true, headerName: "Name", sortable: false, width: 350 },
      { field: "type", width: 150, sortable: false },
      { field: "systemName", headerName: "System Name", width: 334, sortable: false },
      { field: "premiumAIGenericFieldName", headerName: "AI Field", width: 250, sortable: false },
      { field: "", cellRenderer: this.FieldButtons, lockPosition: "right", width: 140, sortable: false }
    ];
    this.setState({ fieldColumnDefs: colDefs });
  }
  componentWillUnmount() {
    FormTypeStore.removeChangeListener(this.onFormTypesChange);
    IndexStore.removeChangeListener(this.onIndexChange);
    FieldRelationsStore.removeChangeListener(this.onFieldRelationsChange);
    FieldStore.removeChangeListener(this.onFieldsChange);
    NavStore.removeChangeListener(this.onNavRequest);
    PremiumAIStore.removeChangeListener(this.onPremiumAIChange);
    SystemAuditLoggingStore.removeChangeListener(this.onSystemAuditChange);
  }
  componentDidUpdate() {
    this.checkParams();
  }
  checkParams() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
    if (formTypeId !== this.state.currentFormType.formTypeId) {
      console.log("checkParams");
      console.log(formTypeId);
      console.log(this.state.currentFormType.formTypeId);
      this.loadFormTypeFromDB();
    }
  }
  onNavRequest() {
    if (this.state.isDirty) {
      let dest = NavStore.getNavDestination();
      this.setState({ showNav: true, navDestination: dest });
    } else {
      AcceptNav();
    }
  }
  FieldButtons(p) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn btn-primary btn-sm btn-circle",
        onClick: () => this.editField(p.data),
        style: { marginLeft: "4px" }
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-pencil" })
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn btn-sm btn-circle",
        onClick: () => this.editExtender(p.data),
        style: {
          marginLeft: "4px",
          backgroundColor: p.data.hasExtender ? "#A1DA35" : "#E8E8E8",
          color: "#fff"
        }
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-list" })
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn btn-danger btn-sm btn-circle",
        onClick: () => this.deleteField(p.data),
        style: { marginLeft: "4px" },
        disabled: p.data.isStandardField
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-times" })
    ));
  }
  loadFormTypeFromDB() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
    if (this.state.currentFormType.formTypeId !== 0 && formTypeId === 0) {
      let newFormType = {
        formTypeId: 0,
        name: "",
        fields: [],
        // to do,  add default steps
        tables: [],
        isNew: true
      };
      this.setState({
        showFieldEditor: false,
        showExtenderEditor: false
      });
      this.setState({ currentFormType: newFormType, isDirty: true });
    } else if (this.state.currentFormType.formTypeId !== formTypeId) {
      LoadFormType(formTypeId);
    }
  }
  onWindowResize(e) {
    this.setState({
      screenHeight: window.innerHeight - windowOffset
    });
  }
  onChangeFTName(e) {
    let ft = this.state.currentFormType;
    ft.name = e.target.value;
    this.setState({ currentFormType: ft, isDirty: true });
  }
  onFormTypesChange() {
    let la = FormTypeStore.getLastAction();
    if (la.actionType === "Update") {
      console.log("update");
      if (la.status === "Success") {
        let newFormType = FormTypeStore.getCurrentFT();
        let preOrderId = this.state.currentFieldSet.orderId;
        if (preOrderId === void 0) preOrderId = 0;
        let fs = newFormType.fieldSets.find((f) => f.orderId === preOrderId);
        this.setState({
          currentFormType: newFormType,
          currentFieldSet: fs,
          isSaving: false,
          isDirty: false,
          showFieldEditor: false,
          showExtenderEditor: false,
          showNav: false
        });
      } else if (la.status === "Error") {
        this.setState({
          isSaving: false,
          isDirty: false,
          showFieldEditor: false,
          showExtenderEditor: false
        });
        let loc = window.location.pathname;
        let pathParts = loc.split("/");
        let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
        LoadFormType(formTypeId);
        GetIndexFieldsForFormType(formTypeId);
      }
      this.setState({ saveState: "ready" });
    }
    if (la.actionType === "FTLoad") {
      let newFormType = FormTypeStore.getCurrentFT();
      let fs = newFormType.fieldSets.find((f) => f.orderId === 0);
      console.log("fs");
      console.log(fs);
      var maxKeyFields = false;
      var keyFieldCount = 0;
      newFormType.fieldSets.forEach((nfs) => {
        let displayOrder = 1;
        nfs.fields.forEach((f) => {
          f.displayOrder = displayOrder;
          displayOrder++;
        });
      });
      if (keyFieldCount >= 5) {
        maxKeyFields = true;
      }
      GetFieldRelations(newFormType.formTypeId);
      this.setState({
        currentFormType: newFormType,
        currentFieldSet: fs,
        isSaving: false,
        isDirty: false,
        showFieldEditor: false,
        showExtenderEditor: false,
        showNav: false
      });
      this.updateFieldList(fs);
      GetIndexFieldsForFormType(newFormType.formTypeId);
      GetBuildPercentage(newFormType.formTypeId);
      GetAllDataSources();
      GetIndexDocCounts(newFormType.formTypeId);
      GetPremiumAIGenericFields();
    }
    if (la.actionType === "ExtenderUpdate") {
      let newFormType = FormTypeStore.getCurrentFT();
      this.setState({
        currentFormType: newFormType,
        //currentFieldSet: fs,
        showFieldEditor: false,
        showExtenderEditor: false
      });
      let cfs = this.state.currentFieldSet;
      console.log(cfs);
      this.updateFieldList(cfs);
    }
    if (la.actionType === "RemoveExtender") {
      let currentFieldSet = this.state.currentFieldSet;
      let editExtender = this.state.editExtender;
      currentFieldSet.fields.forEach((f) => {
        if (f.fieldId === editExtender.fieldId) {
          f.hasExtender = false;
        }
      });
      this.setState({
        showExtenderEditor: false,
        showRemoveExtender: false,
        currentFieldSet
      });
      this.updateFieldList(currentFieldSet);
    }
    if (la.actionType === actionTypes.FTGetAllDataSource) {
      let allSrc = FormTypeStore.getAllDataSources();
      this.setState({ allSources: allSrc });
    }
  }
  onFieldRelationsChange() {
    let la = FieldRelationsStore.lastChange();
    if (la === actionTypes.GetFieldRelations) {
      let fieldRelations = FieldRelationsStore.getFieldRelations();
      this.setState({ fieldRelations });
    }
    if (la === actionTypes.UpdateFieldRelation) {
      GetFieldRelations(this.state.currentFormType.formTypeId);
    }
    if (la === actionTypes.DeleteFieldRelation) {
      this.setState({ displayConfirmDeletePopup: false });
      GetFieldRelations(this.state.currentFormType.formTypeId);
    }
  }
  onFieldsChange() {
    let la = FieldStore.getLastAction();
    if (la.actionType === actionTypes.FieldGetAllForFormType) {
      let fields = FieldStore.getAllFieldsForFormType();
      this.setState({ baseFields: fields });
    }
    if (la.actionType === actionTypes.GetFieldsOtherFormType) {
      let fields = FieldStore.getFieldsOtherFT();
      this.setState({ relatedFields: fields });
    }
    if (la.actionType === actionTypes.GetAllFormTypes) {
      let fts = FieldStore.getAllFormTypes();
      let indexedFts = [];
      fts.forEach((ft) => {
        if (ft.indexId !== null) {
          indexedFts.push(ft);
        }
      });
      this.setState({ formTypes: indexedFts });
    }
  }
  onPremiumAIChange() {
    let la = PremiumAIStore.lastChange();
    if (la === actionTypes.GetPremiumAIGenericFields) {
      let fields = PremiumAIStore.getPremiumAIGenericFields();
      this.setState({ genericFields: fields });
    }
  }
  onIndexChange() {
    let la = IndexStore.getLastAction();
    if (la === actionTypes.IndexUpdate) {
      let currentFT = this.state.currentFormType;
      let indexId = IndexStore.getIndexId();
      currentFT.indexId = indexId;
      this.setState({
        isIndexSectionDirty: false,
        showNewIndex: false,
        doesIndexExist: true,
        currentFormType: currentFT
      });
      if (this.state.startBuildImmediately) {
        this.setState({ startBuildImmediately: false });
        this.showRebuildIndex();
      }
    }
    if (la === actionTypes.GetIndexFieldsByFormTypeId) {
      let indexFields = IndexStore.getIndexFields();
      if (indexFields.length === 0) {
        this.setState({ currentIndexes: indexFields, doesIndexExist: false });
      } else {
        this.setState({ currentIndexes: indexFields, doesIndexExist: indexFields[0].hasIndex });
      }
      let cft = this.state.currentFormType;
      let hfs = cft.fieldSets.find((fs) => fs.name === "Header");
      let ihfs = indexFields.find((fs) => fs.fieldSetName === "Header");
      if (hfs) {
        hfs.fields.forEach((field) => {
          let ifield = ihfs.fields.find((f) => f.fieldId === field.fieldId);
          if (ifield && ifield.hasBasicIndex) {
            field.hasBasicIndex = true;
          } else {
            field.hasBasicIndex = false;
          }
        });
      }
      let indexedFields = [];
      let header = indexFields.find((fs) => fs.fieldSetName === "Header");
      let fields = header.fields;
      fields.forEach((field) => {
        if (field.hasBasicIndex) {
          indexedFields.push(field);
        }
      });
      this.setState({ currentFormType: cft, baseFields: indexedFields });
    }
    if (la === actionTypes.GetBuildPercentage) {
      let buildPercent = IndexStore.getBuildPercent();
      let buildStatus = IndexStore.getBuildStatus();
      if (buildStatus === 0) {
        this.setState({ currentIndexPercent: buildPercent, buildStatus, currentlyIndexing: false });
      } else {
        this.setState({ currentIndexPercent: buildPercent, buildStatus, currentlyIndexing: true });
      }
      if (buildPercent !== 100 && buildPercent !== 0 && !this.state.currentlyIndexing) {
        this.setState({ currentlyIndexing: true });
      }
    }
    if (la === actionTypes.IndexDelete) {
      let currentFT = this.state.currentFormType;
      currentFT.indexId = 0;
      this.setState({
        doesIndexExist: false,
        currentIndexes: [],
        currentFormType: currentFT,
        defaultIndexName: ""
      });
    }
    if (la === actionTypes.IndexGetDocCounts) {
      let counts = IndexStore.getDocCounts();
      this.setState({ activeCount: counts.activeCount });
      this.setState({ completedCount: counts.completeCount });
      this.setState({ deletedCount: counts.deleteCount });
    }
  }
  switchView(newView) {
    if (newView === "relations") {
      GetFieldRelations(this.state.currentFormType.formTypeId);
      GetIndexFieldsForFormType(this.state.currentFormType.formTypeId);
      GetAllFormTypes();
    }
    if (newView === "fields") {
      this.updateFieldList(this.state.currentFieldSet);
    }
    if (newView === "audit") {
      GetFormTypeAudit(this.state.currentFormType.formTypeId);
    }
    this.setState({ currentView: newView });
  }
  onSystemAuditChange() {
    const lastChange = SystemAuditLoggingStore.getLastChange();
    if (lastChange === actionTypes.SystemAuditLogGetLogs) {
      this.setState({ auditLogs: SystemAuditLoggingStore.getLogs() || [] });
    }
    if (lastChange === actionTypes.FormTypeAuditGetLogs) {
      const audit = SystemAuditLoggingStore.getFormTypeAudit() || [];
      const expanded = {};
      if (audit.length > 0) {
        expanded[audit[0].auditSessionId] = true;
      }
      this.setState({
        formTypeAudit: audit,
        expandedAuditSessions: expanded
      });
    }
  }
  toggleAuditSession(sessionId) {
    const expanded = { ...this.state.expandedAuditSessions };
    expanded[sessionId] = !expanded[sessionId];
    this.setState({ expandedAuditSessions: expanded });
  }
  formatAuditTimestamp(timestamp) {
    if (!timestamp) return "";
    try {
      const d = new Date(timestamp);
      if (isNaN(d.getTime())) return timestamp;
      return d.toLocaleString(void 0, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit"
      });
    } catch (e) {
      return timestamp;
    }
  }
  renderAuditValue(val) {
    if (val === null || val === void 0 || val === "") {
      return /* @__PURE__ */ React.createElement("span", { className: "audit-empty-value" }, "(empty)");
    }
    return /* @__PURE__ */ React.createElement("span", null, val);
  }
  auditEntityBadgeColor(entityTypeName) {
    switch (entityTypeName) {
      case "Field":
        return "#A5C8E3";
      case "Field Set":
        return "#E99F5E";
      case "Form Type":
        return "#90C58D";
      case "Relationship":
        return "#D6B4E0";
      case "Extender":
        return "#F5CBA7";
      default:
        return "#D5D5D5";
    }
  }
  auditActionColor(actionTypeName) {
    switch (actionTypeName) {
      case "Create":
        return "#28A70F";
      case "Delete":
        return "#C0392B";
      case "Update":
        return "#2471A3";
      default:
        return "#667";
    }
  }
  addFields() {
    let nf = this.state.newField;
    nf.name = "";
    nf.type = "Text";
    nf.systemName = "";
    this.setState({ addingField: true, newField: nf, lowerHeight: 330 });
  }
  hideaddFields() {
    this.setState({ addingField: false, lowerHeight: 220 });
  }
  addFieldRelations() {
    this.setState({ addingFieldRelation: true });
    this.checkMatchingRelation();
  }
  initialDeleteFieldRelation(fieldRelation) {
    this.setState({
      displayConfirmDeletePopup: true,
      fieldRelationToDelete: fieldRelation.id
    });
  }
  hideaddFieldRelations() {
    this.setState({ addingFieldRelation: false });
  }
  editNewFieldValue(e, property) {
    let field = this.state.newField;
    switch (property) {
      case "name":
        field.name = e.target.value;
        break;
      case "type":
        field.type = e.target.value;
        break;
      case "systemName":
        let sysName = e.target.value;
        if (sysName.length === 1) {
          sysName = sysName.toUpperCase();
        }
        let re = new RegExp("^[A-Z][a-zA-Z0-9]*$");
        if (re.test(sysName) || sysName === "") {
          field.systemName = sysName;
        }
        break;
      default:
        break;
    }
    this.setState({ newField: field });
  }
  camelCase(str) {
    let newStr = str.replace("#", "Num").replace("*", "").replace("(", "").replace(")", "").replace("-", "_").replace("?", "").replace("%", "").replace("/", "").replace(" ", "").replace(/([^a-zA-Z0-9]+)/g, "");
    let numFirst = /^[0-9]/;
    if (numFirst.test(newStr)) {
      newStr = "_" + newStr;
    }
    console.log(newStr);
    return newStr;
  }
  newFieldBlur() {
    let nf = this.state.newField;
    if (nf.systemName === "") {
      let s = nf.name;
      let s2 = this.camelCase(s);
      nf.systemName = s2;
      this.setState({ newField: nf });
    }
  }
  newTableBlur() {
    let nf = this.state.editFieldSet;
    if (nf.systemName === "") {
      let s = nf.name;
      let s2 = this.camelCase(s);
      nf.systemName = s2;
      this.setState({ editFieldSet: nf });
    }
  }
  selectFormType(e, property) {
    GetFieldsForOtherFormType(e.target.value, this.state.selectedBaseField);
    this.setState({ selectedRelatedFormType: e.target.value });
  }
  editSelectedRelatedField(e) {
    this.setState({ selectedRelatedField: e.target.value }, () => this.checkMatchingRelation());
  }
  editSelectedBaseField(e) {
    if (this.state.selectedRelatedFormType !== void 0) {
      GetFieldsForOtherFormType(this.state.selectedRelatedFormType, e.target.value);
    }
    this.setState({ selectedBaseField: e.target.value }, () => this.checkMatchingRelation());
  }
  checkNames(display, sysName, displayOrder) {
    let nameMatch = this.state.currentFieldSet.fields.find((f) => f.name.toUpperCase() === display.toUpperCase() && f.displayOrder !== displayOrder);
    let hasError = false;
    if (nameMatch) {
      console.log("nameMatch");
      hasError = true;
      this.setState({ hasNameMatch: true, nameMatchError: "Duplicated Display Name" });
    }
    let nameMatch2 = this.state.currentFieldSet.fields.find((f) => f.systemName.toUpperCase() === sysName.toUpperCase() && f.displayOrder !== displayOrder);
    if (nameMatch2) {
      hasError = true;
      console.log(nameMatch2);
      this.setState({ hasNameMatch: true, nameMatchError: "Duplicated System Name" });
    }
    if (!hasError) {
      this.setState({ hasNameMatch: false, nameMatchError: "" });
    }
  }
  editFieldValue(e, property) {
    let field = this.state.editField;
    switch (property) {
      case "name":
        this.checkNames(e.target.value, field.systemName, field.displayOrder);
        field.name = e.target.value;
        break;
      case "type":
        console.log(e.target.value);
        field.type = e.target.value;
        break;
      case "systemName":
        this.checkNames(field.name, e.target.value, field.displayOrder);
        let sysName = e.target.value;
        if (sysName.length === 1) {
          sysName = sysName.toUpperCase();
        }
        let re = new RegExp("^[A-Z][a-zA-Z0-9]*$");
        if (re.test(sysName) || sysName === "") {
          field.systemName = sysName;
        }
        break;
      case "isHidden":
        field.isHidden = e.target.checked;
        break;
      case "isConfidential":
        field.isConfidential = e.target.checked;
        break;
      case "currencyCode":
        field.currencyCode = e.target.value;
        break;
      case "isCurrency":
        field.isCurrency = e.target.checked;
        if (field.isCurrency && (field.currencyCode === "" || field.currencyCode === void 0 || field.currencyCode === null)) {
          field.currencyCode = "USD";
        }
        break;
      case "decimalPlaces":
        field.decimalPlaces = parseInt(e.target.value, 10);
        break;
      case "isRunningTotal":
        field.isRunningTotal = e.target.checked;
        break;
      case "format":
        field.format = e.target.value;
        break;
      default:
        break;
    }
    this.setState({ newField: field });
  }
  editExtenderValue(e, property) {
    let extender = this.state.editExtender;
    switch (property) {
      case "type":
        extender.type = parseInt(e.target.value, 10);
        extender.isDirty = true;
        break;
      case "controlsChildren":
        extender.controlsChildren = e.target.checked;
        extender.isDirty = true;
        break;
      case "sortAlphabetical":
        extender.sortAlphabetical = e.target.checked;
        extender.isDirty = true;
        break;
      case "query":
        let q = this.state.currentQuery;
        q.query = e.target.value;
        extender.isDirty = true;
        this.setState({ currentQuery: q });
        break;
      case "defaultValue":
        let q2 = this.state.currentQuery;
        q2.defaultValue = e.target.value;
        extender.isDirty = true;
        this.setState({ currentQuery: q2 });
        break;
      default:
        break;
    }
    this.setState({ editExtender: extender });
  }
  editTableValue(e, property) {
    let fieldSet = this.state.editFieldSet;
    switch (property) {
      case "tableName":
        fieldSet.name = e.target.value;
        break;
      case "isActive":
        fieldSet.isActive = e.target.checked;
        break;
      case "systemName":
        fieldSet.systemName = this.camelCase(e.target.value);
        break;
      default:
        break;
    }
    this.setState({ editFieldSet: fieldSet });
  }
  editAIField(field, genericField) {
    field.premiumAIGenericFieldId = genericField.target.value;
    field.premiumAIGenericFieldName = genericField.target.options[genericField.target.selectedIndex].text;
    this.setState({ editField: field });
  }
  addFieldClick() {
    let hasValidationError = false;
    let validationError = "";
    if (this.state.newField.name.length < 3) {
      hasValidationError = true;
      validationError = "Name is too short";
    }
    if (this.state.newField.systemName.length < 3) {
      hasValidationError = true;
      validationError = "System name is too short";
    }
    const hasMatchingFieldSet = this.state.currentFormType.fieldSets.some(
      (fieldSet) => fieldSet.name.toLowerCase() === this.state.newField.name.toLowerCase()
    );
    const hasMatchingFieldSetToSystemName = this.state.currentFormType.fieldSets.some(
      (fieldSet) => fieldSet.name.toLowerCase() === this.state.newField.systemName.toLowerCase()
    );
    if (hasMatchingFieldSet) {
      hasValidationError = true;
      validationError = "Field name cannot match Field Set name";
    }
    if (hasMatchingFieldSetToSystemName) {
      hasValidationError = true;
      validationError = "Field name cannot match Field Set name";
    }
    let maxOrderId = 1;
    this.state.currentFieldSet.fields.forEach((s) => {
      if (s.displayOrder >= maxOrderId) {
        maxOrderId = s.displayOrder + 1;
      }
      if (s.name.toUpperCase() === this.state.newField.name.toUpperCase()) {
        hasValidationError = true;
        validationError = "Cannot create field with duplicate name";
      }
      if (s.systemName.toUpperCase() === this.state.newField.systemName.toUpperCase()) {
        hasValidationError = true;
        validationError = "Cannot create field with duplicate system name";
      }
    });
    if (!hasValidationError) {
      let fs = this.state.currentFieldSet;
      let ft = this.state.currentFormType;
      let nf = this.state.newField;
      nf.displayOrder = maxOrderId;
      fs.fields.push(nf);
      let newField = {
        name: "",
        type: "Text",
        systemName: "",
        fieldId: 0,
        isDirty: true,
        isRunningTotal: false
      };
      this.setState(
        {
          newField,
          currentFieldSet: fs,
          currentFormType: ft,
          isDirty: true
        },
        () => {
          document.getElementById("new-field-name").focus();
        }
      );
      this.updateFieldList(fs);
    } else {
      PostAlert("error", validationError);
    }
  }
  addFieldRelationClick() {
    UpdateFieldRelation(
      this.state.selectedBaseField,
      this.state.selectedRelatedFormType,
      this.state.selectedRelatedField,
      this.state.isTwoWayLink
    );
    this.hideaddFieldRelations();
  }
  onNewFieldKeyDown(e) {
    if (e.code === "Enter") {
      this.addFieldClick();
    }
  }
  toggleRearrange() {
    let toggle = this.state.isRearranging;
    this.setState({ isRearranging: !toggle });
  }
  editField(field) {
    let edit = {
      name: field.name,
      systemName: field.systemName,
      type: field.type,
      displayOrder: field.displayOrder,
      isHidden: field.isHidden,
      decimalPlaces: field.decimalPlaces,
      isCurrency: field.isCurrency,
      isRunningTotal: field.isRunningTotal,
      currencyCode: field.currencyCode,
      isConfidential: field.isConfidential,
      format: field.format,
      hasBasicIndex: false,
      premiumAIGenericFieldId: field.premiumAIGenericFieldId,
      premiumAIGenericFieldName: field.premiumAIGenericFieldName
    };
    let indexFields = this.state.currentIndexes;
    let ihfs = indexFields.find((fs) => fs.fieldSetName === "Header");
    if (ihfs) {
      let ifield = ihfs.fields.find((f) => f.fieldId === field.fieldId);
      if (ifield && ifield.hasBasicIndex) {
        edit.hasBasicIndex = true;
      } else {
        edit.hasBasicIndex = false;
      }
    }
    this.setState({ showFieldEditor: true, editField: edit });
  }
  editExtender(field) {
    console.log(field);
    let extender = field.extender;
    if (extender === null) {
      extender = {
        extenderId: -1,
        type: 4,
        controlsChildren: false,
        sortAlphabetical: true,
        configured: false,
        dataSources: [],
        extenderDependencies: [],
        fieldId: field.fieldId
      };
      console.log(extender);
    }
    extender.availableDependencies = [];
    let fieldSet = this.state.currentFieldSet;
    if (fieldSet.name !== "Header") {
      let hfieldSet = this.state.currentFormType.fieldSets.find(
        (f) => f.name === "Header"
      );
      if (hfieldSet) {
        let hfields = hfieldSet.fields.sort(
          (a, b) => a.displayOrder < b.displayOrder
        );
        hfields.forEach((hfsField) => {
          if (hfsField.hasExtender) {
            let ex = extender.extenderDependencies.find(
              (f) => f.fieldId === hfsField.fieldId
            );
            if (!ex) {
              let availDep = {
                fieldId: hfsField.fieldId,
                fieldName: hfsField.name,
                controlsChildren: hfsField.extender.controlsChildren,
                sortAlphabetical: hfsField.extender.sortAlphabetical,
                parentFieldId: hfsField.fieldId,
                childFieldId: field.fieldId
              };
              extender.availableDependencies.push(availDep);
            }
          }
        });
      }
    }
    let fields = fieldSet.fields.sort(
      (a, b) => a.displayOrder < b.displayOrder
    );
    fields.forEach((fsField) => {
      if (fsField.hasExtender) {
        let ex = extender.availableDependencies.find(
          (f) => f.fieldId === fsField.fieldId
        );
        if (!ex) {
          let availDep = {
            fieldId: fsField.fieldId,
            fieldName: fsField.name,
            controlsChildren: fsField.extender.controlsChildren,
            sortAlphabetical: fsField.extender.sortAlphabetical,
            parentFieldId: fsField.fieldId,
            childFieldId: field.fieldId
          };
          extender.availableDependencies.push(availDep);
        }
      }
    });
    if (extender === null) {
      extender = {
        extenderId: -1,
        type: 1,
        fieldId: field.fieldId
      };
    } else {
      extender.configured = true;
    }
    extender.fieldName = field.name;
    extender.isDirty = false;
    extender.availableSources = [];
    extender.selectedSource = 0;
    this.state.allSources.forEach((src2) => {
      let exSrc = extender.dataSources.find((ds) => ds.dataSourceId === src2.id);
      if (!exSrc) {
        src2.dataSourceId = src2.id;
        extender.availableSources.push(src2);
      }
    });
    if (extender.dataSources.length > 0) {
      var src = extender.dataSources[0];
      extender.selectedSource = src.dataSourceId;
      this.setState({ currentQuery: src });
    }
    let showDelete = this.state.showOptionRemoveExtender;
    if (extender.extenderId !== -1) {
      showDelete = true;
    } else {
      showDelete = false;
    }
    this.setState({
      editExtender: extender,
      showExtenderEditor: true,
      showFieldEditor: false,
      showOptionRemoveExtender: showDelete
    });
  }
  removeQuery() {
    let src = this.state.currentQuery;
    let extender = this.state.editExtender;
    let idx = extender.dataSources.indexOf(src);
    if (idx >= 0) {
      extender.dataSources.splice(idx, 1);
      extender.availableSources.push(src);
      extender.selectedSource = 0;
    }
    this.setState({ editExtender: extender });
  }
  addDataSrc() {
    let newSrcId = document.getElementById("extenderNewSrcSelect").value;
    if (newSrcId) {
      let extender = this.state.editExtender;
      let allSrcs = extender.availableSources;
      let usedSrc = allSrcs.find((s) => s.id === parseInt(newSrcId));
      let newSrc = {
        dataSourceId: usedSrc.dataSourceId,
        name: usedSrc.name,
        query: ""
      };
      newSrc.dataSourceName = newSrc.name;
      extender.dataSources.push(newSrc);
      extender.selectedSource = newSrc.dataSourceId;
      let idx = extender.availableSources.indexOf(usedSrc);
      if (idx >= 0) {
        allSrcs.splice(idx, 1);
      }
      this.setState({ editExtender: extender, currentQuery: newSrc });
    }
  }
  switchDataSource(src) {
    let extender = this.state.editExtender;
    extender.selectedSource = src.dataSourceId;
    this.setState({ editExtender: extender, currentQuery: src });
  }
  closeExtenderEdit() {
    this.setState({ showExtenderEditor: false });
  }
  configureExtender(field) {
    let extender = this.state.editExtender;
    extender.extenderId = -1;
    extender.configured = true;
    extender.fieldId = field.fieldId;
    console.log("edit");
    console.log(extender);
    this.setState({ editExtender: extender });
  }
  removeExtender() {
    let extender = this.state.editExtender;
    extender.isDirty = true;
    extender.extenderId = -1;
    extender.configured = false;
    this.setState({ editExtender: extender });
  }
  addExtenderDependency() {
    let newDepId = document.getElementById("extenderNewDependency").value;
    if (newDepId) {
      let extender = this.state.editExtender;
      let allDeps = extender.availableDependencies;
      let usedDep = allDeps.find((s) => s.fieldId === parseInt(newDepId));
      let newDep = {
        fieldId: usedDep.fieldId,
        fieldName: usedDep.fieldName,
        controlsChildren: usedDep.controlsChildren,
        sortAlphabetical: usedDep.sortAlphabetical,
        parentFieldId: usedDep.parentFieldId,
        childFieldId: usedDep.fieldId
      };
      extender.extenderDependencies.push(newDep);
      extender.isDirty = true;
      let idx = extender.availableDependencies.indexOf(usedDep);
      if (idx >= 0) {
        allDeps.splice(idx, 1);
      }
      this.setState({ editExtender: extender });
    }
  }
  injectDependency(dep) {
    let extender = this.state.editExtender;
    let queryText = document.getElementById("textareaQuery");
    if (queryText) {
      let start = queryText.selectionStart;
      let end = queryText.selectionEnd;
      let q = this.state.currentQuery;
      let textStart = q.query.substring(0, start);
      let textEnd = q.query.substring(end);
      q.query = textStart + " @ParentKey" + dep.fieldId.toString() + textEnd;
      extender.isDirty = true;
      this.setState({ editExtender: extender, currentQuery: q });
    }
  }
  editCancel() {
    this.setState({ showFieldEditor: false });
  }
  toggleConfirmDelete() {
    this.setState({ displayConfirmDeletePopup: false });
  }
  toggleDeleteTwoWayLink() {
    let toggle = this.state.deleteTwoWayLink;
    this.setState({ deleteTwoWayLink: !toggle });
  }
  toggleAboutFieldRelations() {
    let toggle = this.state.toggleAboutFieldRelations;
    this.setState({ toggleAboutFieldRelations: !toggle });
  }
  toggleAboutFieldType() {
    let toggle = this.state.showAboutFieldType;
    this.setState({ showAboutFieldType: !toggle });
  }
  confirmDeleteFieldRelation() {
    DeleteFieldRelation(
      this.state.fieldRelationToDelete,
      this.state.deleteTwoWayLink
    );
  }
  editUpdate() {
    let edit = this.state.editField;
    let fs = this.state.currentFieldSet;
    let f = fs.fields.find((x) => x.displayOrder === edit.displayOrder);
    if (f) {
      if (edit.name.toLowerCase() === fs.name.toLowerCase()) {
        PostAlert("error", "Field name cannot match Field Set name");
        return;
      }
      if (edit.systemName.toLowerCase() === fs.name.toLowerCase()) {
        PostAlert("error", "Field name cannot match Field Set name");
        return;
      }
      console.log(f);
      f.name = edit.name;
      f.systemName = edit.systemName;
      f.type = edit.type;
      f.isHidden = edit.isHidden;
      f.isConfidential = edit.isConfidential;
      f.decimalPlaces = edit.decimalPlaces;
      f.isCurrency = edit.isCurrency;
      f.isRunningTotal = edit.isRunningTotal;
      f.currencyCode = edit.currencyCode;
      f.format = edit.format;
      f.premiumAIGenericFieldId = edit.premiumAIGenericFieldId;
      f.premiumAIGenericFieldName = edit.premiumAIGenericFieldName;
      this.setState({
        currentFieldSet: fs,
        isDirty: true,
        showFieldEditor: false
      });
      this.updateFieldList(fs);
    }
  }
  switchFieldSet(orderId) {
    let ft = this.state.currentFormType;
    let fs = ft.fieldSets.find((s) => s.orderId === orderId);
    this.setState({ currentFieldSet: fs });
    console.log(fs);
    this.updateFieldList(fs);
  }
  updateFieldList(fs) {
    console.log(fs);
    let fields = [...fs.fields];
    let wh = 200;
    if (fields.length > 0) {
      wh = 53 + fields.length * 42;
    }
    this.setState({ workHeight: wh });
    this.setState({ currentFieldList: fields });
  }
  addNewTableClick() {
    if (this.state.currentFormType.fieldSets.length > 5) {
      PostAlert("error", "You can only have up to 5 detail tables");
    }
    if (this.state.currentFormType.fieldSets.length <= 5) {
      let efs = {
        name: "",
        isActive: true,
        orderId: -1,
        systemName: ""
      };
      this.setState({ editFieldSet: efs, showTableEdit: true });
    } else {
      PostAlert("error", "You can only have up to 5 detail tables");
    }
  }
  addTableClick() {
    if (this.state.currentFormType.fieldSets.length > 5) {
      PostAlert("error", "You can only have up to 5 detail tables");
      return;
    }
    if (this.state.editFieldSet.systemName.length < 3) {
      PostAlert("error", "Table system name must be at least 3 characters");
      return;
    }
    if (this.state.currentFormType.fieldSets.length <= 5) {
      let nfs = {
        name: "",
        fieldSetId: -1,
        orderId: -1,
        isActive: true,
        systemName: ""
      };
      nfs.name = this.state.editFieldSet.name;
      nfs.systemName = this.state.editFieldSet.systemName;
      let maxId = 1;
      this.state.currentFormType.fieldSets.forEach((fs) => {
        if (fs.orderId >= maxId) {
          maxId = fs.orderId + 1;
        }
      });
      nfs.orderId = maxId;
      nfs.fields = [];
      let ft = this.state.currentFormType;
      ft.fieldSets.push(nfs);
      this.setState({
        currentFormType: ft,
        showTableEdit: false,
        isDirty: true
      });
    } else {
      PostAlert("error", "You can only have up to 5 detail tables");
    }
  }
  tableItemClick(fieldSet) {
    let editFs = {
      name: fieldSet.name,
      systemName: fieldSet.systemName,
      isActive: fieldSet.isActive,
      orderId: fieldSet.orderId
    };
    console.log(fieldSet);
    editFs.canDelete = true;
    if (fieldSet.fields !== void 0) {
      fieldSet.fields.forEach((f) => {
        console.log(f);
        if (f.hasData === true) {
          editFs.canDelete = false;
        }
      });
    }
    this.setState({ editFieldSet: editFs, showTableEdit: true });
  }
  cancleTableClick() {
    this.setState({ showTableEdit: false });
  }
  updateTableClick() {
    let efs = this.state.editFieldSet;
    if (efs.systemName.length < 3) {
      PostAlert("error", "Table system name must be at least 3 characters");
      return;
    }
    if (efs.systemName !== "" && efs.systemName.length > 3) {
      let ft = this.state.currentFormType;
      let fs = ft.fieldSets.find((f) => f.orderId === efs.orderId);
      fs.name = efs.name;
      fs.systemName = efs.systemName;
      fs.isActive = efs.isActive;
      this.setState({ currentFormType: ft, showTableEdit: false, isDirty: true });
    }
  }
  rearrangeTableClick(dir) {
    let efs = this.state.editFieldSet;
    let ft = this.state.currentFormType;
    let fs = ft.fieldSets.find((f) => f.orderId === efs.orderId);
    if (dir === "up") {
      let pfs = ft.fieldSets.find((f) => f.orderId === efs.orderId - 1);
      if (pfs.orderId > 0) {
        let o = fs.orderId;
        fs.orderId = pfs.orderId;
        efs.orderId = pfs.orderId;
        pfs.orderId = o;
      }
    }
    if (dir === "down") {
      let nfs = ft.fieldSets.find((f) => f.orderId === efs.orderId + 1);
      if (nfs) {
        let o = fs.orderId;
        fs.orderId = nfs.orderId;
        efs.orderId = nfs.orderId;
        nfs.orderId = o;
      }
    }
    ft.fieldSets.sort((a, b) => a.orderId - b.orderId);
    this.setState({ currentFormType: ft, editFieldSet: efs, isDirty: true });
  }
  rearrangeFieldClick(dir, field) {
    let cfs = this.state.currentFieldSet;
    if (dir === "up") {
      let pf = cfs.fields.find(
        (f) => f.displayOrder === field.displayOrder - 1
      );
      if (pf) {
        let o = field.displayOrder;
        field.displayOrder = pf.displayOrder;
        pf.displayOrder = o;
      }
    }
    if (dir === "down") {
      let nf = cfs.fields.find(
        (f) => f.displayOrder === field.displayOrder + 1
      );
      if (nf) {
        let o = field.displayOrder;
        field.displayOrder = nf.displayOrder;
        nf.displayOrder = o;
      }
    }
    cfs.fields.sort((a, b) => a.displayOrder - b.displayOrder);
    this.setState({ currentFieldSet: cfs, isDirty: true });
  }
  toggleNewIndex() {
    let showNew = this.state.showNewIndex;
    this.setState({ showNewIndex: !showNew });
  }
  toggleDeleteIndex() {
    let showDelete = this.state.showDeleteIndex;
    this.setState({ showDeleteIndex: !showDelete });
  }
  deleteIndex() {
    let newIndexRequest = {
      id: this.state.currentFormType.indexId,
      name: this.state.defaultIndexName,
      formTypeId: this.state.currentFormType.formTypeId,
      //isShared: false,
      startNow: false,
      fields: this.state.currentIndexes
    };
    DeleteIndex(newIndexRequest);
    this.setState({ showDeleteIndex: false });
  }
  reindexDocuments() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
    ReIndexFormType(formTypeId);
    this.setState({ currentlyIndexing: true });
  }
  cancelReindexing() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
    CancelReindexing(formTypeId);
    this.setState({ currentlyIndexing: false, currentIndexPercent: 0 });
  }
  reindexingComplete() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
    UpdateBuildStatus(formTypeId, 0);
    this.setState({ currentlyIndexing: false, currentIndexPercent: 0 });
  }
  editDefaultIndexName(e) {
    this.setState({ defaultIndexName: e.target.value });
  }
  editStartBuildImmediately(e) {
    this.setState({ startBuildImmediately: e.target.checked });
  }
  indexFieldChange(field) {
    let ci = this.state.currentIndexes.find((i) => i.fieldId === field.fieldId);
    let isHeader = false;
    let headerFieldSet = this.state.currentFormType.fieldSets.find(
      (fs) => fs.orderId === 0
    );
    if (headerFieldSet) {
      let headerFields = headerFieldSet.fields;
      let h = headerFields.find((s) => s.fieldId === field.fieldId);
      if (h) isHeader = true;
    }
    if (ci) {
      let indexes = this.state.currentIndexes;
      let idx = indexes.indexOf(ci);
      indexes.splice(idx, 1);
      this.setState({ currentIndexes: indexes, isIndexSectionDirty: true });
    } else {
      let indexes = this.state.currentIndexes;
      indexes.push({
        systemName: field.systemName,
        type: field.type,
        isHeader,
        fieldId: field.fieldId
      });
      this.setState({ currentIndexes: indexes, isIndexSectionDirty: true });
    }
  }
  startIndexCreation() {
    let newIndexRequest = {
      id: this.state.currentFormType.indexId,
      name: this.state.defaultIndexName,
      formTypeId: this.state.currentFormType.formTypeId,
      //isShared: false,
      startNow: false,
      fieldSets: this.state.currentIndexes
    };
    UpdateIndex(newIndexRequest);
  }
  updateIndex() {
    if (this.state.currentFormType.indexId === 0) {
      let ftName = this.state.currentFormType.name;
      this.setState({ showNewIndex: true, defaultIndexName: ftName });
    } else {
      let newIndexRequest = {
        id: this.state.currentFormType.indexId,
        name: this.state.defaultIndexName,
        formTypeId: this.state.currentFormType.formTypeId,
        //isShared: false,
        startNow: false,
        fieldSets: this.state.currentIndexes
      };
      UpdateIndex(newIndexRequest);
    }
  }
  updateIndexAndReindex() {
    let newIndexRequest = {
      id: this.state.currentFormType.indexId,
      name: this.state.defaultIndexName,
      formTypeId: this.state.currentFormType.formTypeId,
      //isShared: false,
      startNow: false,
      fieldSets: this.state.currentIndexes
    };
    UpdateIndex(newIndexRequest);
    this.setState({ startBuildImmediately: true });
  }
  onSave() {
    UpdateFormType(this.state.currentFormType);
    this.setState({ isSaving: true });
  }
  saveExtenderChanges() {
    console.log(this.state.editExtender);
    this.setState({ errorMessageForExtenders: "" });
    let ext = this.state.editExtender;
    if (ext.type === 0) {
      PostAlert("error", "Please set or reselect a Control Type");
      return;
    }
    if (ext.selectedSource <= 0) {
      PostAlert("error", "Please set a data source");
      return;
    }
    if (ext.dataSources.length <= 0) {
      PostAlert("error", "Please configure a data source");
      return;
    }
    for (let i = 0; i < ext.dataSources.length; i++) {
      let x = ext.dataSources[i];
      if (x.query === "") {
        PostAlert("error", "Please enter a query");
        return;
      }
      if (x.query.indexOf("Key") === -1) {
        PostAlert("error", "Query must contain Key");
        return;
      }
      if (x.query.indexOf("Value") === -1) {
        PostAlert("error", "Query must contain Value");
        return;
      }
      if (ext.extenderDependencies.length > 0) {
        for (let h = 0; h < ext.extenderDependencies.length; h++) {
          let dep = ext.extenderDependencies[h];
          if (!dep.controlsChildren) {
            let strToFind = "@ParentKey" + dep.fieldId.toString();
            if (x.query.indexOf(strToFind) === -1) {
              PostAlert(
                "error",
                "Query must contain a reference to its parent:" + strToFind
              );
              return;
            }
          }
        }
      }
    }
    UpdateExtender(this.state.editExtender);
  }
  onTimerClick() {
    if (this.state.currentlyIndexing === true) {
      let loc = window.location.pathname;
      let pathParts = loc.split("/");
      let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
      GetBuildPercentage(formTypeId);
    }
  }
  toggleRemoveExtender() {
    let removeExtender = this.state.showRemoveExtender;
    let showOptionRemoveExtender = this.state.showOptionRemoveExtender;
    this.setState({
      showRemoveExtender: !removeExtender,
      showOptionRemoveExtender: !showOptionRemoveExtender
    });
  }
  generatePluginModel() {
    GetPluginModel(this.state.currentFormType.formTypeId);
  }
  onConfirmRemoveExtender() {
    let extender = this.state.editExtender;
    RemoveExtender(extender);
  }
  toggleTwoWayLink() {
    let toggle = this.state.isTwoWayLink;
    this.setState({ isTwoWayLink: !toggle });
  }
  deleteField(field) {
    let fs = this.state.currentFieldSet;
    let f = fs.fields.find((fd) => fd.fieldId === field.fieldId);
    let idx = fs.fields.indexOf(f);
    fs.fields.splice(idx, 1);
    this.setState({ currentFieldSet: fs, isDirty: true });
    this.updateFieldList(fs);
  }
  removeTableClick() {
    let fs = this.state.editFieldSet;
    let ft = this.state.currentFormType;
    console.log(fs);
    console.log(ft);
    let fs2 = ft.fieldSets.find((f) => f.orderId === fs.orderId);
    let idx = ft.fieldSets.indexOf(fs2);
    console.log(idx);
    ft.fieldSets.splice(idx, 1);
    console.log(ft);
    this.setState({ isDirty: true, currentFormType: ft, showTableEdit: false });
  }
  setFieldDragging(field) {
    this.dragField = field;
  }
  onFieldDragOver(e, field) {
    let fieldId = `fieldDiv-${field.displayOrder}`;
    let el = document.getElementById(fieldId);
    if (el) {
      let clientRect = el.getBoundingClientRect();
      if (clientRect.y < e.clientY && e.clientY < clientRect.y + clientRect.height / 2) {
        this.setState({
          dropOverId: field.fieldId,
          dropUnderId: 0
        });
      }
      if (clientRect.y + clientRect.height / 2 < e.clientY && e.clientY < clientRect.y + clientRect.height) {
        this.setState({
          dropOverId: 0,
          dropUnderId: field.fieldId
        });
      }
    }
    if (this.dragField !== void 0 && this.dragField.fieldId !== field.fieldId) {
      let fs = this.state.currentFieldSet;
      this.dragTarget = field;
      this.setState({ currentFieldSet: fs });
    }
  }
  onFieldDrop() {
    let fs = this.state.currentFieldSet;
    let currentFields = fs.fields;
    currentFields.sort((a, b) => a.displayOrder - b.displayOrder);
    let idx = currentFields.indexOf(this.dragField);
    let fieldMove = false;
    if (this.state.dropOverId !== parseInt(this.dragField.fieldId, 10) && this.state.dropUnderId !== this.dragField.fieldId) {
      console.log("remove");
      currentFields.splice(idx, 1);
      fieldMove = true;
      if (this.state.dropOverId !== 0) {
        let proxTarget = currentFields.find((f) => f.fieldId === this.state.dropOverId);
        if (proxTarget) {
          let idx2 = currentFields.indexOf(this.dragTarget);
          currentFields.splice(idx2, 0, this.dragField);
        }
      }
      if (this.state.dropUnderId !== 0) {
        let proxTarget = currentFields.find((f) => f.fieldId === this.state.dropUnderId);
        if (proxTarget) {
          let idx2 = currentFields.indexOf(proxTarget);
          currentFields.splice(idx2 + 1, 0, this.dragField);
        }
      }
    }
    let displayIdx = 1;
    currentFields.forEach((s) => {
      s.displayOrder = displayIdx;
      displayIdx++;
    });
    this.dragTarget = void 0;
    this.dragField = void 0;
    if (fieldMove) {
      currentFields.sort((a, b) => a.displayOrder - b.displayOrder);
      this.setState({ currentFieldSet: fs, isDirty: true, dropOverId: 0, dropUnderId: 0 });
    }
  }
  toggleSelectAllIndex(fs) {
    let indexes = this.state.currentIndexes;
    let headerFieldSet = indexes.find(
      (fs2) => fs2.fieldSetId === fs.fieldSetId
    );
    let allChecked = true;
    headerFieldSet.fields.forEach((field) => {
      if (!field.hasBasicIndex) {
        allChecked = false;
      }
    });
    if (allChecked) {
      headerFieldSet.fields.forEach((field) => {
        field.hasBasicIndex = false;
        field.hasSqlIndex = false;
      });
    } else {
      headerFieldSet.fields.forEach((field) => {
        field.hasBasicIndex = true;
      });
    }
    this.setState({ currentIndexes: indexes, isIndexSectionDirty: true });
  }
  RemoveIndexOption(fieldSetId, fieldId, removeOption) {
    let indexes = this.state.currentIndexes;
    let fieldSet = indexes.find((fs) => fs.fieldSetId === fieldSetId);
    if (fieldSet) {
      let field = fieldSet.fields.find((f) => f.fieldId === fieldId);
      if (field) {
        switch (removeOption) {
          case "sql":
            field.hasSqlIndex = false;
            field.useTextIndex = false;
            break;
          case "text":
            field.useTextIndex = false;
            field.hasSqlIndex = false;
            break;
          case "basic":
            field.hasBasicIndex = false;
            field.hasSqlIndex = false;
            break;
          default:
            break;
        }
        this.setState({ currentIndexes: indexes, isIndexSectionDirty: true });
      }
    }
  }
  onRowDragMove(e) {
    let body = document.getElementById("mainBody");
    let rect = body.getBoundingClientRect();
    let t = rect.y;
    let t2 = rect.y + rect.height;
    if (body.scrollTop > 0 && e.event.clientY > t - 20 && e.event.clientY < t + 40) {
      body.scrollTop = body.scrollTop - 5;
    }
    if (rect.height + body.scrollTop < body.scrollHeight && e.event.clientY > t2 - 40 && e.event.clientY < t2 + 20) {
      body.scrollTop = body.scrollTop + 5;
    }
  }
  AddIndexOption(fieldSetId, fieldId, addOption) {
    let indexes = this.state.currentIndexes;
    let fieldSet = indexes.find((fs) => fs.fieldSetId === fieldSetId);
    if (fieldSet) {
      let field = fieldSet.fields.find((f) => f.fieldId === fieldId);
      if (field) {
        switch (addOption) {
          case "sql":
            field.hasSqlIndex = true;
            field.hasBasicIndex = true;
            break;
          case "text":
            field.useTextIndex = true;
            break;
          case "basic":
            field.hasBasicIndex = true;
            break;
          default:
            break;
        }
        this.setState({ currentIndexes: indexes, isIndexSectionDirty: true });
      }
    }
  }
  toggleRebuildIndex() {
    let show = this.state.showReindex;
    this.setState({ showReindex: !show });
  }
  showRebuildIndex() {
    var rco = {
      indexAll: true,
      colOptions: []
    };
    let indexFieldSets = this.state.currentIndexes;
    let ihs = indexFieldSets.find((fs) => fs.fieldSetName === "Header");
    if (ihs) {
      ihs.fields.forEach((field) => {
        rco.colOptions.push({
          colId: field.fieldId,
          colName: field.systemName,
          reindex: true
        });
      });
    }
    this.setState({ reindexColumnOptions: rco });
    this.setState({ showReindex: true });
  }
  changeReindexSettings(e, change, colId) {
    console.log(change);
    if (change === "active") {
      this.setState({ reindexActiveDocs: e.target.checked });
    }
    if (change === "complete") {
      this.setState({ reindexCompleteDocs: e.target.checked });
    }
    if (change === "delete") {
      this.setState({ reindexDeletedDocs: e.target.checked });
    }
    if (change === "columns") {
      this.setState({ reindexColumns: e.target.checked });
    }
    if (change === "text") {
      this.setState({ reindexText: e.target.checked });
    }
    if (change === "related") {
      this.setState({ reindexRelated: e.target.checked });
    }
    if (change === "allColumns") {
      let rco = this.state.reindexColumnOptions;
      rco.indexAll = e.target.checked;
      rco.colOptions.forEach((col) => {
        col.reindex = e.target.checked;
      });
      this.setState({ reindexColumnOptions: rco });
    }
    if (change === "column") {
      let rco = this.state.reindexColumnOptions;
      let col = rco.colOptions.find((c) => c.colId === colId);
      if (col) {
        col.reindex = e.target.checked;
      }
      this.setState({ reindexColumnOptions: rco });
    }
  }
  startIndexBuild() {
    let ftId = this.state.currentFormType.formTypeId;
    let params = {
      includeActive: this.state.reindexActiveDocs,
      includeDeleted: this.state.reindexDeletedDocs,
      includeCompleted: this.state.reindexCompleteDocs,
      rebuildTextIndex: this.state.reindexText,
      rebuildRelatedCounts: this.state.reindexRelated
    };
    ReIndexFormTypeWithParams(ftId, params);
    this.setState({ showReindex: false });
    this.setState({ currentlyIndexing: true });
  }
  onSaveAndNav() {
    this.onSave();
    AcceptNav();
  }
  onStay() {
    this.setState({ showNav: false });
  }
  onDiscardAndNav() {
    AcceptNav();
  }
  onFieldRowDragMove(event) {
    const movingNode = event.node;
    const overNode = event.overNode;
    const rowNeedsToMove = movingNode.data.name !== overNode.data.name;
    if (rowNeedsToMove) {
      let immutableStore = [...this.state.currentFieldList];
      const movingData = event.node.data;
      const fromIndex = immutableStore.indexOf(movingData);
      const toIndex = event.node.childIndex;
      const newStore = immutableStore.slice();
      const element = newStore[fromIndex];
      newStore.splice(fromIndex, 1);
      newStore.splice(toIndex, 0, element);
      let order = 1;
      let cfs = this.state.currentFormType.fieldSets.find((f) => f.fieldSetId === this.state.currentFieldSet.fieldSetId);
      let newFields = [];
      let snap = [...cfs.fields];
      let toMove = snap.find((f) => f.name === event.node.data.name);
      let toMoveIdx = snap.indexOf(toMove);
      snap.splice(toMoveIdx, 1);
      snap.splice(event.node.childIndex, 0, toMove);
      snap.forEach((f) => {
        f.displayOrder = order;
        order++;
      });
      cfs.fields = snap;
      console.log(cfs);
      this.setState({ isDirty: true });
    }
  }
  checkMatchingRelation() {
    if (this.state.selectedRelatedField === this.state.selectedBaseField) {
      this.setState({ isTwoWayLink: false, enableTwoWayLink: false });
    } else {
      this.setState({ enableTwoWayLink: true });
    }
  }
  removeExtenderDependency(extender) {
    let extenderUpdate = { ...this.state.editExtender };
    let deps = [...extenderUpdate.extenderDependencies];
    let depToRemove = deps.find((f) => f.fieldId === extender.fieldId);
    if (depToRemove) {
      let idx = deps.indexOf(depToRemove);
      deps.splice(idx, 1);
      console.log(deps);
      extenderUpdate.extenderDependencies = deps;
      extenderUpdate.isDirty = true;
      this.setState({ editExtender: extenderUpdate });
    }
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "sidebarLayout d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "sidebar-container" }, /* @__PURE__ */ React.createElement(FormTypeSidebar, null)), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: {
          display: "grid",
          gridTemplateColumns: "650px 1fr",
          gridTemplateRows: "150px 40px 1fr 15px"
        }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "ftInfo",
          className: "card",
          style: { gridColumn: "1", gridRow: "1", margin: "16px" }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-file-alt" }), " Form Type"),
        /* @__PURE__ */ React.createElement("div", { className: "card-body", style: { margin: "2px" } }, /* @__PURE__ */ React.createElement("div", { className: "row mb-3" }, /* @__PURE__ */ React.createElement("label", { className: "col-sm-2 col-form-label", htmlFor: "txtFTName" }, "Name:"), /* @__PURE__ */ React.createElement("div", { className: "col-sm-10" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "txtFTName",
            value: this.state.currentFormType.name,
            onChange: this.onChangeFTName,
            placeholder: "Form Type Name"
          }
        ))))
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "userPills",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "2 / 2",
            marginLeft: "16px"
          }
        },
        /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills" }, /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `nav-link ${this.state.currentView === "fields" ? "active" : ""}`,
            style: { cursor: "pointer" },
            onClick: () => this.switchView("fields")
          },
          "Fields"
        )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `nav-link ${this.state.currentView === "tables" ? "active" : ""}`,
            style: { cursor: "pointer" },
            onClick: () => this.switchView("tables")
          },
          "Tables"
        )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `nav-link ${this.state.currentView === "relations" ? "active" : ""}`,
            style: { cursor: "pointer" },
            onClick: () => this.switchView("relations")
          },
          "Relations"
        )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `nav-link ${this.state.currentView === "index" ? "active" : ""}`,
            style: { cursor: "pointer" },
            onClick: () => this.switchView("index")
          },
          "Indexes"
        )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `nav-link ${this.state.currentView === "audit" ? "active" : ""}`,
            style: { cursor: "pointer" },
            onClick: () => this.switchView("audit")
          },
          "Audit"
        )), this.state.currentFormType.businessProcessId !== 0 && /* @__PURE__ */ React.createElement("li", { className: "nav-item pt-2 ms-4" }, /* @__PURE__ */ React.createElement("span", { style: { cursor: "pointer" } }, /* @__PURE__ */ React.createElement(
          Link,
          {
            to: `/Admin/BusinessProcess/${this.state.currentFormType.businessProcessId}`,
            style: { textDecoration: "none", color: "#000" }
          },
          /* @__PURE__ */ React.createElement("span", { style: { color: "#B023DD" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-th-large" })),
          " ",
          this.state.currentFormType.businessProcessName
        ))), this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement("li", { className: "nav_item" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-success",
            onClick: this.onSave,
            style: { marginLeft: "30px" }
          },
          /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-save" }),
          " Save Changes"
        )), this.state.isSaving && /* @__PURE__ */ React.createElement("li", { className: "nav_item" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-success",
            style: { marginLeft: "30px", width: "100px" }
          },
          /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-spinner", spin: true })
        )))
      ),
      this.state.currentView === "fields" && /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "ftFields",
          className: "card",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "3 / 3",
            margin: "16px",
            position: "relative"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-body pb-2" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            id: "mainBody",
            className: "row",
            style: {
              marginLeft: "10px",
              height: `${this.state.screenHeight}px`,
              overflow: "auto",
              padding: "2px"
            }
          },
          /* @__PURE__ */ React.createElement("div", { id: "userPills", style: { paddingLeft: "0px" } }, /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills" }, this.state.currentFormType.fieldSets.sort((a, b) => a.orderId > b.orderId ? 1 : -1).map((fieldSet) => /* @__PURE__ */ React.createElement("li", { className: "nav-item nav-sm", key: fieldSet.orderId }, /* @__PURE__ */ React.createElement(
            "span",
            {
              className: `nav-link nav-sm ${this.state.currentFieldSet.orderId === fieldSet.orderId ? "active" : ""}`,
              style: { cursor: "pointer" },
              onClick: () => this.switchFieldSet(fieldSet.orderId)
            },
            fieldSet.name
          ))))),
          this.state.currentFieldSet !== void 0 && /* @__PURE__ */ React.createElement("div", { className: "ag-theme-quartz  mt-2", style: { width: "1250px", height: `${this.state.workHeight}px` } }, /* @__PURE__ */ React.createElement(
            AgGridReact,
            {
              rowData: this.state.currentFieldList,
              columnDefs: this.state.fieldColumnDefs,
              domLayout: "autoHeight",
              onRowDragEnd: this.onFieldRowDragMove,
              onRowDragMove: this.onRowDragMove,
              rowDragManaged: true,
              suppressMoveWhenRowDragging: true
            }
          )),
          false,
          !this.state.addingField && /* @__PURE__ */ React.createElement("div", { style: { marginTop: "8px" } }, /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-success",
              onClick: this.addFields
            },
            /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
            " Add fields",
            " "
          )),
          /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-primary btn-circle btn-sm",
              style: { marginTop: "8px" },
              title: "integration setup",
              onClick: this.generatePluginModel
            },
            /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-code" })
          )),
          this.state.addingField && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
            "div",
            {
              style: {
                border: "solid 1px #BBB",
                borderRadius: "8px",
                marginTop: "16px",
                padding: "8px",
                marginLeft: "-3px",
                marginRight: "-1px",
                backgroundColor: "#EEE"
              }
            },
            /* @__PURE__ */ React.createElement("strong", null, "New Field:"),
            /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Name:"), /* @__PURE__ */ React.createElement(
              "input",
              {
                type: "text",
                id: "new-field-name",
                className: "form-control",
                value: this.state.newField.name,
                onKeyDown: this.onNewFieldKeyDown,
                onBlur: this.newFieldBlur,
                onChange: (event) => this.editNewFieldValue(event, "name"),
                placeholder: "Field name"
              }
            )), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Type:"), /* @__PURE__ */ React.createElement(
              "select",
              {
                className: "form-select",
                value: this.state.newField.type,
                onKeyDown: this.onNewFieldKeyDown,
                onChange: (event) => this.editNewFieldValue(event, "type")
              },
              /* @__PURE__ */ React.createElement("option", { value: "Text" }, "Text"),
              /* @__PURE__ */ React.createElement("option", { value: "Number" }, "Number"),
              /* @__PURE__ */ React.createElement("option", { value: "Date" }, "Date")
            )), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "System Name:"), /* @__PURE__ */ React.createElement(
              "input",
              {
                type: "text",
                className: "form-control",
                value: this.state.newField.systemName,
                onChange: (event) => this.editNewFieldValue(event, "systemName"),
                onKeyDown: this.onNewFieldKeyDown,
                placeholder: "system Name"
              }
            ))),
            /* @__PURE__ */ React.createElement(
              "button",
              {
                style: { marginTop: "4px" },
                className: "btn btn-success",
                onClick: this.addFieldClick
              },
              "Add Field"
            ),
            /* @__PURE__ */ React.createElement(
              "button",
              {
                style: { marginTop: "4px", marginLeft: "4px" },
                className: "btn btn-secondary",
                onClick: this.hideaddFields
              },
              "Close"
            )
          ))
        ))
      ),
      this.state.currentView === "fields" && this.state.showFieldEditor && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "3 / 3",
            margin: "45px",
            zIndex: "95",
            maxHeight: "420px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Edit field :", " ", /* @__PURE__ */ React.createElement("strong", null, this.state.editField.systemName)),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtFieldName", className: "form-label" }, "Display as:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "txtFieldName",
            value: this.state.editField.name,
            onChange: (event) => this.editFieldValue(event, "name")
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "selType", className: "form-label" }, "Type:"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.editField.type,
            onChange: (event) => this.editFieldValue(event, "type")
          },
          /* @__PURE__ */ React.createElement("option", { value: "Text" }, "Text"),
          /* @__PURE__ */ React.createElement("option", { value: "Number" }, "Number"),
          /* @__PURE__ */ React.createElement("option", { value: "Date" }, "Date")
        )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-check-inline mt-2" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input me-1",
            checked: this.state.editField.isHidden,
            onChange: (event) => this.editFieldValue(event, "isHidden"),
            type: "checkbox"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Hidden"))), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtSysName", className: "form-label" }, "System Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "txtFieldName",
            value: this.state.editField.systemName,
            onChange: (event) => this.editFieldValue(event, "systemName"),
            disabled: this.state.editField.hasBasicIndex
          }
        )), this.state.editField.type === "Number" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Number of decimal places:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "number",
            className: "form-control",
            id: "txtFieldName",
            value: this.state.editField.decimalPlaces,
            onChange: (event) => this.editFieldValue(event, "decimalPlaces")
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "row mt-2" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-check-inline" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input me-1",
            checked: this.state.editField.isCurrency,
            onChange: (event) => this.editFieldValue(event, "isCurrency"),
            type: "checkbox"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Currency?"))), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, this.state.editField.isCurrency && /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.editField.currencyCode,
            onChange: (event) => this.editFieldValue(event, "currencyCode")
          },
          /* @__PURE__ */ React.createElement("option", { value: "USD" }, "$ Dollar"),
          /* @__PURE__ */ React.createElement("option", { value: "GBP" }, "\xA3 Pound"),
          /* @__PURE__ */ React.createElement("option", { value: "EUR" }, "\u20AC Euro"),
          /* @__PURE__ */ React.createElement("option", { value: "RUB" }, "\u20BD Ruble"),
          /* @__PURE__ */ React.createElement("option", { value: "JPY" }, "\xA5 Yen"),
          /* @__PURE__ */ React.createElement("option", { value: "PHP" }, "\u20B1 Peso")
        ))), this.state.currentFieldSet.name !== "Header" && /* @__PURE__ */ React.createElement("div", { className: "row mt-1" }, /* @__PURE__ */ React.createElement("div", { className: "col-12" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-check-inline" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            checked: this.state.editField.isRunningTotal,
            onChange: (event) => this.editFieldValue(
              event,
              "isRunningTotal"
            ),
            type: "checkbox"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Show column total"))))), this.state.editField.type === "Date" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Date Format:"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.editField.format,
            onChange: (event) => this.editFieldValue(event, "format")
          },
          /* @__PURE__ */ React.createElement("option", { value: "mm/dd/yyyy" }, "mm/dd/yyyy"),
          /* @__PURE__ */ React.createElement("option", { value: "dd/mm/yyyy" }, "dd/mm/yyyy"),
          /* @__PURE__ */ React.createElement("option", { value: "mm-dd-yyyy" }, "mm-dd-yyyy")
        )))), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtFieldName", className: "form-label" }, "AI Field:"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.editField.premiumAIGenericFieldId,
            onChange: (event) => this.editAIField(this.state.editField, event)
          },
          /* @__PURE__ */ React.createElement("option", { value: "-1" }, "None"),
          this.state.genericFields.filter(
            (src) => this.state.currentFieldSet.name === "Header" ? src.header === true : src.header !== true
          ).map((src) => /* @__PURE__ */ React.createElement("option", { key: src.id, value: src.id }, src.genericFieldName))
        )))), /* @__PURE__ */ React.createElement("div", { className: "row mt-2 mb-2" }), this.state.hasNameMatch && /* @__PURE__ */ React.createElement("div", { className: "alert alert-danger" }, this.state.nameMatchError), !this.state.hasNameMatch && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-success mt-2",
            onClick: this.editUpdate
          },
          "Update"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-secondary mt-2 mx-1",
            onClick: this.editCancel
          },
          "Cancel"
        ))),
        this.state.showAboutFieldType && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "td-dialogue card",
            style: { height: "200px", width: "400px" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "About Field Type", /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.toggleAboutFieldType,
              className: "btn-close"
            }
          )),
          /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Field types cannot be changed while they are indexed. You must remove it from the index before you are able to update the field type."))))
        ))
      ),
      this.state.currentView === "fields" && this.state.showExtenderEditor && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "3 / 3",
            margin: "45px",
            zIndex: "100",
            maxHeight: "650px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Extender for:", " ", /* @__PURE__ */ React.createElement("strong", null, this.state.editExtender.fieldName), /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            className: "btn-close",
            style: { float: "right" },
            onClick: this.closeExtenderEdit
          }
        )),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, this.state.editExtender.configured && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Control Type"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.editExtender.type,
            onChange: (e) => this.editExtenderValue(e, "type")
          },
          /* @__PURE__ */ React.createElement("option", { value: "1" }, "AutoComplete"),
          /* @__PURE__ */ React.createElement("option", { value: "4" }, "Dropdown")
        )), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch mt-4" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            checked: this.state.editExtender.controlsChildren,
            onChange: (e) => this.editExtenderValue(e, "controlsChildren"),
            className: "form-check-input",
            type: "checkbox"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Controls Data Source of Children")), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch mt-4" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            checked: this.state.editExtender.sortAlphabetical,
            onChange: (e) => this.editExtenderValue(e, "sortAlphabetical"),
            className: "form-check-input",
            type: "checkbox"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Alphabetize List")))), /* @__PURE__ */ React.createElement("label", { className: "form-label mt-3" }, "Queries"), this.state.editExtender.dataSources.length === 0 && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "pt-4 pb-4 ms-2",
            style: { fontWeight: 700, color: "#A0A0A0" }
          },
          "There are no queries for this extender ",
          ":("
        ), /* @__PURE__ */ React.createElement("div", { className: "d-flex" }, /* @__PURE__ */ React.createElement("div", { className: "me-auto" }, /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills" }, this.state.editExtender.dataSources.map((src) => /* @__PURE__ */ React.createElement("li", { className: "nav-item", key: src.dataSourceId }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: `nav-link nav-sm ${src.dataSourceId === this.state.editExtender.selectedSource ? "active" : ""} `,
            style: { cursor: "pointer" },
            onClick: () => this.switchDataSource(src)
          },
          src.dataSourceName
        ))))), /* @__PURE__ */ React.createElement("div", { className: "ms-auto" }, this.state.editExtender.selectedSource > 0 && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-sm btn-danger",
            onClick: this.removeQuery
          },
          "Remove Query"
        ))), this.state.editExtender.selectedSource > 0 && this.state.currentQuery !== void 0 && /* @__PURE__ */ React.createElement("code", null, /* @__PURE__ */ React.createElement(
          "textarea",
          {
            id: "textareaQuery",
            className: "form-control mt-1 sqlEditor",
            value: this.state.currentQuery.query,
            onChange: (e) => this.editExtenderValue(e, "query"),
            rows: "5"
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "d-flex" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto mt-3" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            id: "extenderNewSrcSelect"
          },
          this.state.editExtender.availableSources.map(
            (src) => /* @__PURE__ */ React.createElement("option", { key: src.id, value: src.id }, src.name)
          )
        )), /* @__PURE__ */ React.createElement("div", { className: "col-auto mt-3" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-success col-auto",
            onClick: this.addDataSrc
          },
          "Add Query for this Data Source"
        )), /* @__PURE__ */ React.createElement("div", { className: "row mt-2 ms-auto" }, this.state.editExtender.selectedSource > 0 && this.state.currentQuery !== void 0 && /* @__PURE__ */ React.createElement("div", { className: "row me-auto mt-1" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { className: "col-form-label" }, "Default Value")), /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            value: this.state.currentQuery.defaultValue,
            onChange: (e) => this.editExtenderValue(e, "defaultValue")
          }
        ))), /* @__PURE__ */ React.createElement("div", null))), /* @__PURE__ */ React.createElement("hr", { className: "mt-3" }), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Dependencies:")), /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills" }, this.state.editExtender.extenderDependencies.map(
          (dep) => /* @__PURE__ */ React.createElement("li", { className: "nav-item ms-2", key: dep.fieldId }, /* @__PURE__ */ React.createElement(
            "span",
            {
              className: `${dep.controlsChildren ? "nav-link3" : "nav-link2"} nav-sm`
            },
            dep.controlsChildren && /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-database"
              }
            ),
            !dep.controlsChildren && /* @__PURE__ */ React.createElement(
              "i",
              {
                style: { cursor: "pointer" },
                onClick: () => this.injectDependency(dep),
                className: "fa-solid fa-at"
              }
            ),
            " ",
            dep.fieldName,
            " ",
            /* @__PURE__ */ React.createElement(
              "i",
              {
                style: { cursor: "pointer" },
                className: "fa-solid fa-times",
                onClick: () => this.removeExtenderDependency(dep)
              }
            )
          ))
        )))), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto mt-1" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select form-select-sm",
            id: "extenderNewDependency"
          },
          this.state.editExtender.availableDependencies.map(
            (dep) => /* @__PURE__ */ React.createElement("option", { key: dep.fieldId, value: dep.fieldId }, dep.fieldName)
          )
        )), /* @__PURE__ */ React.createElement("div", { className: "col-auto mt-1" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-sm btn-success col-auto",
            onClick: this.addExtenderDependency
          },
          "Add Dependency"
        ))), /* @__PURE__ */ React.createElement("hr", { className: "mt-3" }), this.state.editExtender.isDirty && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-success mt-3",
            onClick: this.saveExtenderChanges
          },
          "Save extender changes"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger mt-3 ms-1",
            onClick: this.toggleRemoveExtender
          },
          "Remove extender"
        ), /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              color: "#FF0000",
              fontSize: "14pt"
            }
          },
          /* @__PURE__ */ React.createElement("br", null),
          this.state.errorMessageForExtenders
        )), !this.state.editExtender.configured && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              color: "#9D9D9D",
              fontSize: "12pt"
            }
          },
          "No extender configured"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary mt-2",
            onClick: this.configureExtender
          },
          "Configure extender"
        )))
      ),
      this.state.currentView === "tables" && /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "ftTables",
          className: "card",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "3 / 3",
            margin: "16px",
            position: "relative"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Tables"),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("div", { style: { margin: "8px" } }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Detail Tables:"), /* @__PURE__ */ React.createElement("div", { className: "td-detail-desc" }, "Each entry here creates a new table tab."), /* @__PURE__ */ React.createElement("div", { className: "td-sel-list" }, /* @__PURE__ */ React.createElement("ul", null, this.state.currentFormType.fieldSets.sort((a, b) => a.orderId > b.orderId ? 1 : -1).map((fs) => /* @__PURE__ */ React.createElement(
          "li",
          {
            key: fs.orderId,
            style: {
              display: fs.orderId === 0 ? "none" : "block"
            },
            onClick: () => this.tableItemClick(fs)
          },
          fs.name
        )))), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-sm btn-success",
            onClick: this.addNewTableClick
          },
          "Add Table"
        ))), /* @__PURE__ */ React.createElement("div", { className: "col-8" }, this.state.showTableEdit && /* @__PURE__ */ React.createElement("div", { style: { margin: "16px" } }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Table Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            value: this.state.editFieldSet.name,
            onBlur: this.newTableBlur,
            onChange: (event) => this.editTableValue(event, "tableName"),
            placeholder: "table name"
          }
        ), /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "System Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            value: this.state.editFieldSet.systemName,
            onChange: (event) => this.editTableValue(event, "systemName"),
            placeholder: "system name"
          }
        ), this.state.editFieldSet.fieldSetId > -1 && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "form-check form-switch",
            style: { marginTop: "6px" }
          },
          /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              checked: this.state.editFieldSet.isActive,
              onChange: (event) => this.editTableValue(event, "isActive")
            }
          ),
          /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Active")
        ), /* @__PURE__ */ React.createElement("div", { style: { marginTop: "4px" } }, this.state.editFieldSet.orderId === -1 && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-success",
            style: { marginRight: "4px" },
            onClick: this.addTableClick,
            disabled: this.state.editFieldSet.name.length === 0
          },
          "Add"
        ), this.state.editFieldSet.orderId > -1 && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-success",
            style: { marginRight: "4px" },
            onClick: this.updateTableClick,
            disabled: this.state.editFieldSet.name.length === 0
          },
          "Update"
        ), this.state.editFieldSet.canDelete && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginRight: "4px" },
            onClick: this.removeTableClick
          },
          "Remove"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-secondary",
            style: { marginRight: "4px" },
            onClick: this.cancleTableClick
          },
          "Cancel"
        ), this.state.editFieldSet.orderId > -1 && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary btn-circle",
            style: { marginRight: "4px" },
            disabled: this.state.editFieldSet.orderId === 1,
            onClick: () => this.rearrangeTableClick("up")
          },
          /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-arrow-up" })
        ), this.state.editFieldSet.orderId > -1 && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary btn-circle",
            style: { marginRight: "4px" },
            onClick: () => this.rearrangeTableClick("down")
          },
          /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-arrow-down" })
        ))))))
      ),
      this.state.currentView === "relations" && /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "ftTables",
          className: "card",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "3 / 3",
            margin: "16px",
            position: "relative"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "col-3 pt-3",
            style: {
              display: "inline-block",
              verticalAlign: "middle",
              fontWeight: "bold"
            }
          },
          "Field Relations",
          " ",
          /* @__PURE__ */ React.createElement(
            "i",
            {
              className: "fa-solid fa-circle-info",
              onClick: () => this.toggleAboutFieldRelations()
            }
          )
        )),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            id: "ftRelations",
            className: "",
            style: {
              gridColumnStart: "1",
              gridColumnEnd: "3",
              gridRow: "3 / 3",
              position: "relative"
            }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement(
            "div",
            {
              className: "row",
              style: {
                maxHeight: "100%",
                overflow: "auto"
              }
            },
            /* @__PURE__ */ React.createElement("table", { className: "wf-StepTable" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Base Field"), /* @__PURE__ */ React.createElement("th", null, "Related Form Type"), /* @__PURE__ */ React.createElement("th", null, "Related Field"), /* @__PURE__ */ React.createElement("th", null))), /* @__PURE__ */ React.createElement("tbody", null, this.state.fieldRelations.map((fieldRelation) => /* @__PURE__ */ React.createElement("tr", { key: fieldRelation.id }, /* @__PURE__ */ React.createElement("td", null, fieldRelation.baseFieldName), /* @__PURE__ */ React.createElement("td", null, fieldRelation.relatedFormTypeName), /* @__PURE__ */ React.createElement("td", null, fieldRelation.relatedFieldName), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("span", { style: { color: "red" } }, /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-trash",
                onClick: () => this.initialDeleteFieldRelation(
                  fieldRelation
                )
              }
            ), " ")))))),
            !this.state.addingFieldRelation && /* @__PURE__ */ React.createElement("div", { style: { marginTop: "8px", paddingLeft: "0px" } }, /* @__PURE__ */ React.createElement(
              "button",
              {
                className: "btn btn-success",
                onClick: this.addFieldRelations
              },
              /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
              " Add field relation",
              " "
            )),
            this.state.addingFieldRelation && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
              "div",
              {
                style: {
                  border: "solid 1px #BBB",
                  borderRadius: "8px",
                  marginTop: "16px",
                  padding: "8px",
                  marginLeft: "-3px",
                  marginRight: "-1px",
                  backgroundColor: "#EEE"
                }
              },
              /* @__PURE__ */ React.createElement("strong", null, "New Field Relation:"),
              /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Base Field"), /* @__PURE__ */ React.createElement(
                "select",
                {
                  className: "form-select",
                  value: this.state.selectedBaseField,
                  onChange: (event) => this.editSelectedBaseField(event)
                },
                /* @__PURE__ */ React.createElement("option", { value: "" }, ""),
                this.state.baseFields.map((field) => /* @__PURE__ */ React.createElement("option", { value: field.fieldId }, field.name))
              )), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Related Form Type:", " "), /* @__PURE__ */ React.createElement(
                "select",
                {
                  className: "form-select",
                  value: this.state.selectedRelatedFormType,
                  onChange: (event) => this.selectFormType(event, "type")
                },
                /* @__PURE__ */ React.createElement("option", { value: "" }, ""),
                this.state.formTypes.map((ft) => /* @__PURE__ */ React.createElement("option", { value: ft.formTypeId }, ft.name))
              )), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Related Field:"), /* @__PURE__ */ React.createElement(
                "select",
                {
                  className: "form-select",
                  value: this.state.selectedRelatedField,
                  onChange: (event) => this.editSelectedRelatedField(event)
                },
                /* @__PURE__ */ React.createElement("option", { value: "" }, ""),
                this.state.relatedFields.map((field) => /* @__PURE__ */ React.createElement("option", { value: field.fieldId }, field.name))
              )), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Two way link:", " "), /* @__PURE__ */ React.createElement(
                "input",
                {
                  className: "form-check-input",
                  style: { marginLeft: "4px" },
                  type: "checkbox",
                  disabled: !this.state.enableTwoWayLink,
                  checked: this.state.isTwoWayLink,
                  onChange: () => this.toggleTwoWayLink()
                }
              ))),
              /* @__PURE__ */ React.createElement(
                "button",
                {
                  style: { marginTop: "4px" },
                  className: "btn btn-success",
                  onClick: this.addFieldRelationClick
                },
                "Add Field Relation"
              ),
              /* @__PURE__ */ React.createElement(
                "button",
                {
                  style: { marginTop: "4px", marginLeft: "4px" },
                  className: "btn btn-secondary",
                  onClick: this.hideaddFieldRelations
                },
                "Close"
              )
            ))
          ))
        )),
        this.state.displayConfirmDeletePopup && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "td-dialogue card",
            style: { height: "175px", width: "400px" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Delete Field Relation", /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.toggleConfirmDelete,
              className: "btn-close"
            }
          )),
          /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "form-check  mt-2" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              checked: this.state.deleteTwoWayLink,
              onChange: this.toggleDeleteTwoWayLink
            }
          ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Delete Two Way Link (If exists)")), /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.confirmDeleteFieldRelation,
              className: "btn btn-danger mt-3 w-100"
            },
            "Confirm Delete"
          ))
        )),
        this.state.toggleAboutFieldRelations && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "td-dialogue card",
            style: { height: "240px", width: "400px" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "About Field Relations", /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.toggleAboutFieldRelations,
              className: "btn-close"
            }
          )),
          /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Field relations can only be established using form types and fields that are indexed; unindexed fields will not be displayed. Additionally, a Base Field and a Related Field must share the same data type for a field relationship to be created. If you encounter difficulties linking two fields, ensure that they have matching data types."))))
        ))
      ),
      this.state.currentView === "index" && /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "ftTables",
          className: "card",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "3 / 3",
            margin: "16px",
            position: "relative"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "col-3 pt-3",
            style: {
              display: "inline-block",
              verticalAlign: "middle",
              fontWeight: "bold"
            }
          },
          "Searching"
        ), this.state.doesIndexExist && !this.state.currentlyIndexing && !this.state.isIndexSectionDirty && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "m-2",
            style: { display: "inline-block", float: "right" }
          },
          /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.showRebuildIndex,
              className: "mt-1 me-1 btn btn-primary"
            },
            "Reindex Documents"
          )
        )),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, this.state.currentlyIndexing && this.state.buildStatus === 1 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "row justify-content-center" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "col-6 m-1",
            style: { textAlign: "center", fontWeight: "bold" }
          },
          "Indexing Progress: ",
          this.state.currentIndexPercent,
          "%"
        )), /* @__PURE__ */ React.createElement("div", { className: "row justify-content-center" }, /* @__PURE__ */ React.createElement("div", { className: "col-lg m-3" }, /* @__PURE__ */ React.createElement("div", { className: "progress" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "progress-bar bg-info",
            role: "progressbar",
            style: {
              width: this.state.currentIndexPercent.toString() + "%"
            },
            "aria-valuenow": "50",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        )))), this.state.currentlyIndexing && this.state.currentIndexPercent === 100 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "row justify-content-center" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "col-6 mb-3",
            style: { textAlign: "center" }
          },
          "Reindexing Complete"
        )), /* @__PURE__ */ React.createElement("div", { className: "row justify-content-center" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "col-6",
            style: { textAlign: "center" }
          },
          /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.reindexingComplete,
              className: "mt-1 me-1 btn btn-success"
            },
            "Ok!"
          )
        ))), this.state.currentlyIndexing && this.state.currentIndexPercent !== 100 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "row justify-content-center mb-3" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "col-6",
            style: { textAlign: "center" }
          },
          /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.cancelReindexing,
              className: "mt-1 me-1 btn btn-danger"
            },
            "Cancel Reindexing"
          )
        )))), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" } }, /* @__PURE__ */ React.createElement("span", { className: "redCheck" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-square-check" })), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            style: { marginLeft: "4px" }
          },
          "Show in Active Documents",
          " "
        ), /* @__PURE__ */ React.createElement("span", { className: "greenCheck", style: { marginLeft: "8px" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-square-check" })), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            style: { marginLeft: "4px" }
          },
          "Enable Searching",
          " "
        )), /* @__PURE__ */ React.createElement("div", { className: "row " }, this.state.currentIndexes.map((fs) => /* @__PURE__ */ React.createElement("div", { className: "col-auto", key: fs.orderId }, /* @__PURE__ */ React.createElement("div", { className: "ft-search-colheader" }, " ", fs.orderId === 0 && /* @__PURE__ */ React.createElement(
          "i",
          {
            style: { cursor: "pointer" },
            className: "fa-solid fa-square-check",
            onClick: () => this.toggleSelectAllIndex(fs)
          }
        ), " ", fs.fieldSetName), /* @__PURE__ */ React.createElement("div", { style: { margin: "6px" } }, fs.fields.map((field) => /* @__PURE__ */ React.createElement("div", { key: field.displayOrder }, fs.fieldSetName === "Header" && /* @__PURE__ */ React.createElement("span", { className: "redCheck" }, field.hasBasicIndex && /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fa-solid fa-square-check",
            onClick: () => this.RemoveIndexOption(
              fs.fieldSetId,
              field.fieldId,
              "basic"
            )
          }
        ), !field.hasBasicIndex && /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fa-regular fa-square",
            onClick: () => this.AddIndexOption(
              fs.fieldSetId,
              field.fieldId,
              "basic"
            )
          }
        )), /* @__PURE__ */ React.createElement("span", { className: "greenCheck" }, (field.hasSqlIndex || field.useTextIndex) && /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fa-solid fa-square-check",
            onClick: () => this.RemoveIndexOption(
              fs.fieldSetId,
              field.fieldId,
              "text"
            )
          }
        ), !field.hasSqlIndex && !field.useTextIndex && /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fa-regular fa-square",
            onClick: () => this.AddIndexOption(
              fs.fieldSetId,
              field.fieldId,
              "text"
            )
          }
        )), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            style: { marginLeft: "4px" }
          },
          field.name
        ))))))), !this.state.currentlyIndexing && /* @__PURE__ */ React.createElement("div", null, this.state.doesIndexExist && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.updateIndex,
            disabled: !this.state.isIndexSectionDirty,
            className: "mt-1 me-1 btn btn-success"
          },
          "Update"
        )), !this.state.doesIndexExist && /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.toggleNewIndex,
            className: "mt-1 me-1 btn btn-success"
          },
          "Create Search Index"
        ), this.state.doesIndexExist && /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.toggleDeleteIndex,
            className: "mt-1 me-1 btn btn-danger"
          },
          "Delete Search Index"
        )), this.state.showNewIndex && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "td-dialogue card",
            style: { height: "220px", width: "400px" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "New Search Index", /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.toggleNewIndex,
              className: "btn-close"
            }
          )),
          /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { className: "form-label mt-1" }, "Name:")), /* @__PURE__ */ React.createElement("div", { className: "col-auto " }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-control",
              placeholder: "index name",
              value: this.state.defaultIndexName,
              onChange: this.editDefaultIndexName
            }
          ))), /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.startIndexCreation,
              className: "btn btn-primary mt-3 w-100",
              disabled: this.state.defaultIndexName.length === 0
            },
            "Create"
          ))
        )), this.state.showDeleteIndex && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "td-dialogue card",
            style: { height: "250px", width: "400px" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Delete Index", /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.toggleDeleteIndex,
              className: "btn-close"
            }
          )),
          /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-auto" }, /* @__PURE__ */ React.createElement("label", { className: "form-label mt-1" }, "Deleting this index will result in the removal of any related fields configured for this form type. Additionally, it will eliminate fields from displaying on active documents and may impact search performance by slowing down response times."))), /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.deleteIndex,
              className: "btn btn-danger mt-2 w-100"
            },
            "Delete"
          ))
        )), this.state.showReindex && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "td-dialogue card",
            style: { height: "510px", width: "400px" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Rebuild Search Index", /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.toggleRebuildIndex,
              className: "btn-close"
            }
          )),
          /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              checked: this.state.reindexActiveDocs,
              onChange: (e) => this.changeReindexSettings(e, "active")
            }
          ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Active ", `(${this.state.activeCount})`)), /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              checked: this.state.reindexCompleteDocs,
              onChange: (e) => this.changeReindexSettings(e, "complete")
            }
          ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Completed ", `(${this.state.completedCount})`)), /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              checked: this.state.reindexDeletedDocs,
              onChange: (e) => this.changeReindexSettings(e, "delete")
            }
          ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Deleted ", `(${this.state.deletedCount})`))), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              checked: this.state.reindexText,
              onChange: (e) => this.changeReindexSettings(e, "text")
            }
          ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Rebuild Text Index", " ")), /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              checked: this.state.reindexRelated,
              onChange: (e) => this.changeReindexSettings(e, "related")
            }
          ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, "Rebuild Related Counts", " "))), /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: this.startIndexBuild,
              className: "btn btn-primary mt-3 w-100"
            },
            "Start Build"
          ))
        )))
      ),
      this.state.currentView === "audit" && /* @__PURE__ */ React.createElement(
        "div",
        {
          id: "ftAudit",
          className: "card",
          style: {
            gridColumnStart: "1",
            gridColumnEnd: "3",
            gridRow: "3 / 3",
            margin: "16px",
            position: "relative"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("div", { className: "col-3 pt-2 audit-header-title" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-timeline audit-header-icon" }), " ", "Change History")),
        /* @__PURE__ */ React.createElement("div", { className: "card-body audit-scroll" }, this.state.formTypeAudit.length === 0 && /* @__PURE__ */ React.createElement("div", { className: "audit-empty" }, "No changes recorded for this form type yet."), this.state.formTypeAudit.map((session) => {
          const isOpen = !!this.state.expandedAuditSessions[session.auditSessionId];
          return /* @__PURE__ */ React.createElement("div", { key: session.auditSessionId, className: "audit-session" }, /* @__PURE__ */ React.createElement(
            "div",
            {
              className: `audit-session-header${isOpen ? " is-open" : ""}`,
              onClick: () => this.toggleAuditSession(session.auditSessionId)
            },
            /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-user audit-header-icon" }),
            /* @__PURE__ */ React.createElement("div", { className: "audit-session-user" }, session.userName),
            /* @__PURE__ */ React.createElement("div", { className: "audit-session-timestamp" }, this.formatAuditTimestamp(session.changedAt)),
            /* @__PURE__ */ React.createElement("div", { className: "audit-session-count" }, session.changes.length, " ", session.changes.length === 1 ? "change" : "changes"),
            /* @__PURE__ */ React.createElement(
              "i",
              {
                className: `fa-solid audit-session-chevron ${isOpen ? "fa-angle-up" : "fa-angle-down"}`
              }
            )
          ), isOpen && /* @__PURE__ */ React.createElement("div", { className: "audit-session-body" }, session.changes.map((change) => /* @__PURE__ */ React.createElement("div", { key: change.id, className: "audit-change-row" }, /* @__PURE__ */ React.createElement(
            "span",
            {
              className: "audit-action-label",
              style: { color: this.auditActionColor(change.actionTypeName) }
            },
            change.actionTypeName
          ), /* @__PURE__ */ React.createElement(
            "span",
            {
              className: "audit-entity-badge",
              style: { background: this.auditEntityBadgeColor(change.entityTypeName) }
            },
            change.entityTypeName,
            change.entityName ? `: ${change.entityName}` : ""
          ), /* @__PURE__ */ React.createElement("span", { className: "audit-change-detail" }, change.actionTypeName === "Create" && /* @__PURE__ */ React.createElement("span", { style: { color: "#28A70F" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }), " ", "Added ", change.entityTypeName.toLowerCase(), " ", /* @__PURE__ */ React.createElement("strong", null, change.entityName), change.entityTypeName === "Extender" && change.newValue !== null && /* @__PURE__ */ React.createElement(React.Fragment, null, " for data source ", change.newValue, " ")), change.actionTypeName === "Delete" && /* @__PURE__ */ React.createElement("span", { style: { color: "#C0392B" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-minus" }), " ", "Removed ", change.entityTypeName.toLowerCase(), " ", /* @__PURE__ */ React.createElement("strong", null, change.entityName)), change.actionTypeName === "Update" && (change.propertyName && change.propertyName?.endsWith("Query") ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", { className: "audit-property-label" }, change.propertyName, ":"), "Query was updated", /* @__PURE__ */ React.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-sm btn-outline-secondary audit-show-updates-btn",
              onClick: () => this.setState({
                queryDiffPopup: {
                  propertyName: change.propertyName,
                  oldValue: change.oldValue,
                  newValue: change.newValue
                }
              })
            },
            "Show updates"
          )) : /* @__PURE__ */ React.createElement("span", null, change.propertyName && /* @__PURE__ */ React.createElement("strong", { className: "audit-property-label" }, change.propertyName, ":"), this.renderAuditValue(change.oldValue), /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-arrow-right audit-change-arrow" }), this.renderAuditValue(change.newValue))))))));
        }))
      ),
      this.state.queryDiffPopup && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement("div", { className: "td-dialogue card audit-diff-card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, this.state.queryDiffPopup.propertyName, /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: () => this.setState({ queryDiffPopup: null }),
          className: "btn-close"
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "card-body audit-diff-body" }, /* @__PURE__ */ React.createElement("div", { className: "audit-diff-grid" }, /* @__PURE__ */ React.createElement("div", { className: "audit-diff-pane" }, /* @__PURE__ */ React.createElement("strong", { className: "audit-diff-pane-label" }, "Old Value"), /* @__PURE__ */ React.createElement("pre", { className: "audit-diff-pre" }, this.state.queryDiffPopup.oldValue || "")), /* @__PURE__ */ React.createElement("div", { className: "audit-diff-pane" }, /* @__PURE__ */ React.createElement("strong", { className: "audit-diff-pane-label" }, "New Value"), /* @__PURE__ */ React.createElement("pre", { className: "audit-diff-pre" }, this.state.queryDiffPopup.newValue || ""))))))
    ), this.state.showNav && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "td-dialogue card bg-light",
        style: { height: "259px", width: "400px" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Unsaved changes"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body", style: { display: "block" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-warning" }), " You have unsaved changes"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success btn-block mt-2",
          style: { width: "360px" },
          onClick: this.onSaveAndNav
        },
        "Save changes and go to ",
        this.state.navDestination
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-info btn-block mt-2",
          style: { width: "360px" },
          onClick: this.onStay
        },
        "Stay in FormType Editor"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-secondary btn-block mt-2",
          style: { width: "360px" },
          onClick: this.onDiscardAndNav
        },
        "Discard changes and go to ",
        this.state.navDestination
      ))
    )), this.state.showRemoveExtender && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container", style: { zIndex: "200" } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "td-dialogue card",
        style: { height: "220px", width: "400px", zIndex: "110" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Remove extender", /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.toggleRemoveExtender,
          className: "btn-close"
        }
      )),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", null, "Are you sure you want to remove this extender?"), /* @__PURE__ */ React.createElement("div", { className: "pt-2" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-danger",
          onClick: this.onConfirmRemoveExtender
        },
        "Yes - Remove"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-secondary ms-2",
          onClick: this.toggleRemoveExtender
        },
        "No - Cancel"
      )))
    )));
  }
}
export default FormTypeView;
